import {favoritesRu} from "./favorites-ru";
import {contentRu} from "./content-ru";
import {notificationsRu} from "./notifications-ru";
import {ordersRu} from "./orders-ru";
export const ru = {
 orders: ordersRu,
  favorites: favoritesRu,
  notifications: notificationsRu,
  content: contentRu,
  common: {
    brand: "Magistika",
    backToHome: "Вернуться на главную",
    requestId: "Номер обращения",
    retry: "Повторить",
  },
  meta: {
    authTitle: "Вход и регистрация — Magistika",
    passwordResetTitle: "Восстановление пароля — Magistika",
    phoneRecoveryTitle: "Подтверждение нового телефона — Magistika",
    spaTitle: "Личный кабинет — Magistika",
    favoritesTitle: "Избранное — Magistika",
    notificationsTitle: "Уведомления — Magistika",
    notificationPreferencesTitle: "Настройки уведомлений — Magistika",
    authNoScriptTitle: "Для входа нужен JavaScript",
    authNoScriptBody: "Публичные страницы сайта доступны без JavaScript. Для безопасной регистрации и работы с браузерной сессией включите JavaScript.",
    spaNoScript: "Для личного кабинета нужен JavaScript.",
    adminTitle: "Пользователи — админка Magistika",
    expertTitle: "Кабинет эксперта — Magistika",
    guestConsultationTitle: "Гостевая консультация — Magistika",
  },
  auth: {
    dialogTitle: "Вход и регистрация",
    close: "Закрыть",
    chooseAction: "Выберите действие",
    signupTab: "Регистрация",
    signinTab: "Вход",
    signupTitle: "Создать аккаунт",
    signinTitle: "Войти",
    firstName: "Имя",
    lastName: "Фамилия (необязательно)",
    email: "Email",
    emailOptional: "Email (необязательно, если указан телефон)",
    phoneOptional: "Телефон (необязательно, если указан email)",
    phoneLabel: "Телефон",
    login: "Email или телефон",
    birthDate: "Дата рождения",
    password: "Пароль",
    passwordConfirmation: "Повторите пароль",
    termsPrefix: "Я принимаю",
    termsLink: "правила сервиса",
    sending: "Отправляем…",
    register: "Зарегистрироваться",
    signIn: "Войти",
    completeTitle: "Проверьте почту",
    completeBody: "Регистрация завершена. Откройте письмо и подтвердите email.",
    goToSignin: "Перейти ко входу",
    emailConfirmTitle: "Подтверждение email",
    emailConfirmBody: "Подтвердите адрес, чтобы завершить регистрацию и войти.",
    confirming: "Подтверждаем…",
    confirmEmail: "Подтвердить email",
    phone: {
      title: "Подтверждение телефона",
      requestBody: "Отправим шестизначный код по SMS. Номер будет подтверждён только после правильного ввода кода.",
      changeBody: "Укажите другой номер и запросите новый код.",
      requestCode: "Отправить код",
      requesting: "Отправляем код…",
      codeTitle: "Введите код из SMS",
      codeBody: "Код отправлен на номер {{phone}} и действует 10 минут.",
      codeLabel: "Шестизначный код",
      confirm: "Подтвердить телефон",
      confirming: "Проверяем код…",
      resend: "Отправить ещё раз",
      resendIn: "Отправить ещё раз через {{seconds}} с",
      expiresIn: "Код действует ещё {{seconds}} с",
      expired: "Срок действия кода истёк. Запросите новый код.",
      exhausted: "Попытки ввода исчерпаны. Запросите новый код.",
      taken: "Этот номер уже принадлежит другому активному аккаунту.",
      change: "Указать другой номер",
      successTitle: "Телефон подтверждён",
      successBody: "Завершаем вход в аккаунт.",
    },
    captcha: {
      prompt: "Подтвердите, что запрос отправляет человек.",
      widgetLabel: "Проверка безопасности",
      loading: "Загружаем проверку безопасности…",
      ready: "Проверка безопасности готова.",
      verified: "Проверка безопасности пройдена.",
      expired: "Проверка истекла. Пройдите её ещё раз.",
      error: "Не удалось загрузить проверку безопасности. Проверьте соединение или блокировщик и повторите попытку.",
      retry: "Загрузить проверку ещё раз",
    },
    passwordReset: {
      forgot: "Забыли пароль?",
      requestTitle: "Восстановить пароль",
      requestBody: "Укажите подтверждённый email или телефон. Если восстановление доступно, мы отправим одноразовую ссылку или код.",
      request: "Получить ссылку или код",
      requesting: "Отправляем…",
      requestedTitle: "Проверьте сообщения",
      requestedBody: "Если аккаунт существует и восстановление доступно, ссылка или код уже отправлены.",
      requestAgain: "Запросить ещё раз",
      backToSignin: "Вернуться ко входу",
      completeTitle: "Задайте новый пароль",
      completeBody: "Введите новый пароль. Ссылка действует один раз в течение 30 минут.",
      phoneTitle: "Введите код и новый пароль",
      code: "Шестизначный код",
      newPassword: "Новый пароль",
      passwordConfirmation: "Повторите новый пароль",
      complete: "Сохранить новый пароль",
      completing: "Сохраняем…",
      resend: "Запросить новый код",
      successTitle: "Пароль изменён",
      successBody: "Все прежние сессии завершены. Сейчас откроется страница входа.",
      goToSignin: "Войти с новым паролем",
      signinSuccess: "Пароль изменён. Войдите с новым паролем.",
    },
  },
  session: {
    loading: "Загружаем кабинет…",
    loadErrorTitle: "Не удалось загрузить кабинет",
    anonymousTitle: "Нужно войти",
    anonymousBody: "Личный кабинет доступен после аутентификации.",
    greeting: "Здравствуйте, {{name}}",
    shellBody: "Основа личного кабинета готова. Продуктовые разделы появятся в WP-6.10 и WP-6.11.",
    logout: "Выйти",
    accountLink: "Личный кабинет, {{name}}",
    impersonationAria: "Режим работы от имени пользователя",
    impersonationTitle: "Вы работаете от имени другого пользователя",
    impersonationBody: "Целевой аккаунт: {{target}}, ID {{targetId}}. Исходный оператор: ID {{operatorId}}.",
    impersonationStop: "Вернуться в свой аккаунт",
    impersonationStopping: "Возвращаем…",
    impersonationStopError: "Не удалось завершить режим. Повторите попытку или выйдите из аккаунта.",
  },
  consultation: {
    entry: {
      loadingTitle: "Открываем запись к эксперту",
      loadingBody: "Сохраняем выбранного эксперта и открываем расписание.",
      invalidTitle: "Ссылка на запись недействительна",
      invalidBody: "Откройте запись заново из карточки эксперта.",
      forbiddenTitle: "Запись недоступна для этого аккаунта",
      forbiddenBody: "Аккаунт эксперта не может оформить консультацию. Войдите как клиент.",
      timezoneBody: "Не удалось определить часовой пояс браузера. Проверьте настройки браузера и повторите попытку.",
      unavailableBody: "Запись к этому эксперту сейчас недоступна. Выберите другой вариант из карточки эксперта.",
      staleBody: "Черновик уже изменился. Откройте его актуальное состояние и продолжите выбор.",
      errorBody: "Не удалось открыть запись. Повторите запрос: уже начатая операция будет продолжена.",
    },
    eyebrow: "Новая консультация",
    loadingTitle: "Создаём черновик",
    loadingBody: "Подготавливаем мастер оформления консультации.",
    loadErrorTitle: "Черновик не удалось открыть",
    loadErrorBody: "Повторите запрос. Выборы не будут восстановлены из локальной копии — актуальное состояние хранит сервис консультаций.",
    expires: "Черновик действует до {{date}}",
    cancel: "Отменить черновик",
    progressAria: "Шаги оформления консультации",
    progress: {
      expert: "Эксперт",
      channel: "Канал",
      schedule: "Формат",
      duration: "Время",
      phone_verification: "Телефон",
      review: "Проверка",
    },
    steps: {
      expert: "Выберите эксперта",
      channel: "Выберите канал",
      schedule: "Выберите формат",
      duration: "Выберите длительность",
      phone_verification: "Подтвердите телефон",
      review: "Проверьте заказ",
      submitted: "Заказ передан",
      expired: "Черновик истёк",
    },
    notices: {
      feature_unavailable: "Этот вариант пока недоступен. Вы можете изменить выбор и продолжить с доступным форматом.",
      recovered: "Актуальное состояние черновика загружено.",
    },
    conflictTitle: "Черновик уже изменился",
    conflictBody: "Показанные данные устарели. Мы не объединяем их автоматически: перечитайте актуальный черновик отдельным действием.",
    reloadDraft: "Перечитать черновик",
    expertTitle: "Выберите эксперта",
    expertBody: "Выберите эксперта из актуального каталога. Доступность и цена будут проверены сервисом консультаций.",
    expertsLoading: "Загружаем экспертов…",
    expertLoading: "Загружаем актуальные данные эксперта…",
    expertsEmpty: "Подходящих экспертов сейчас нет.",
    perMinute: "за минуту",
    channelTitle: "Как оформить консультацию?",
    channelBody: "Мастер оформляет голосовой заказ до состояния, указанного сервисом. Текстовый формат будет честно отмечен как недоступный, если его ещё нельзя оформить.",
    voice: "Голосом",
    voiceBody: "Оформление голосового заказа без обещания запуска звонка на этом шаге.",
    text: "Текстом",
    textBody: "Текстовые консультации находятся в следующей очереди поставки.",
    modeTitle: "Нужно ли указать время?",
    modeBody: "Можно отправить заказ без времени или выбрать слот. Бронирование ещё не резервирует календарь до подтверждённой поставки WP-3.12.",
    unscheduled: "Без расписания",
    unscheduledBody: "Оформление заказа без закреплённого времени.",
    booking: "Выбрать время",
    bookingBody: "Выберите доступный слот; при отправке сервис честно вернёт текущую доступность функции.",
    slotTitle: "Выберите время",
    slotBody: "Показаны актуальные слоты в часовом поясе браузера. Сервис повторно проверит слот перед оформлением.",
    slotsLoading: "Загружаем доступные слоты…",
    slotsEmpty: "Свободных слотов в ближайшие две недели нет.",
    slotUntil: "до {{date}}",
    durationTitle: "Сколько времени нужно?",
    durationBody: "Варианты получены из текущего черновика. Мастер не рассчитывает и не подменяет их самостоятельно.",
    durationOutsideSlot: "Длительность должна помещаться в выбранное окно. Для более долгой консультации выберите время заново.",
    reselectSlot: "Выбрать другое время",
    durationEmpty: "Сервис не предложил доступную длительность.",
    minutes: "{{count}} мин",
    reviewTitle: "Всё верно?",
    reviewBody: "Цена и доступность будут проверены ещё раз при отправке. Этот мастер заканчивается на order_processing или payment_required и не обещает оплату либо запуск звонка.",
    summaryExpert: "Эксперт",
    summaryFormat: "Формат",
    summaryDuration: "Длительность",
    summarySlot: "Время",
    summaryRate: "Ставка",
    summaryTotal: "Итого",
    summaryUnavailable: "Данные эксперта обновляются",
    priceChangedTitle: "Цена изменилась",
    priceChangedBody: "Ранее: {{before}}. Сейчас: {{after}}. Проверьте новую сумму и подтвердите её отдельным действием.",
    submit: "Отправить заказ",
    submitting: "Отправляем…",
    acceptNewPrice: "Принять новую цену и отправить",
    startOver: "Изменить выбор",
    submittedTitle: "Заявка принята",
    submittedBody: "Черновик отправлен. Показаны только ссылки и дальнейшее действие, которые вернул сервис.",
    orderProcessing: "Создание заказа ещё обрабатывается. Проверка выполняется только по вашей команде.",
    orderRef: "Номер заказа",
    bookingRef: "Номер бронирования",
    checkOrder: "Проверить состояние",
    refreshing: "Проверяем…",
    paymentPay: "Оплатить с кошелька",
    paymentPaying: "Оплачиваем…",
    paymentPaidTitle: "Оплата подтверждена",
    paymentPaidBody: "Сервис консультаций подтвердил оплату. Начало звонка и очередь эксперта появятся только в соответствующих разделах после их готовности.",
    paymentPaidAt: "Подтверждено {{date}}",
    paymentInsufficientTitle: "Недостаточно средств",
    paymentInsufficientBody: "На кошельке не хватает средств. Откройте кошелёк, пополните его доступным способом и повторите оплату отдельным действием.",
    paymentOpenWallet: "Открыть кошелёк",
    paymentRecoveryTitle: "Платёж ещё проверяется",
    paymentRecoveryBody: "Сервис восстанавливает точный результат операции. Оплата пока не подтверждена; действие можно повторить.",
    paymentCompensatedTitle: "Оплата не завершена",
    paymentCompensatedBody: "Денежный эффект был компенсирован. Заказ не отмечен оплаченным.",
    paymentUnavailableTitle: "Оплата временно недоступна",
    paymentUnavailableBody: "Сервис не подтвердил платёж. Средства и состояние заказа не угадываются; повторите действие позже.",
    paymentForbiddenTitle: "Нет доступа к оплате",
    paymentForbiddenBody: "Этот заказ нельзя оплатить из текущего аккаунта. Оплата не подтверждена.",
    paymentNotFoundTitle: "Заказ не найден",
    paymentNotFoundBody: "Сервис не нашёл доступный вам заказ. Оплата не выполнялась.",
    paymentConflictTitle: "Состояние заказа изменилось",
    paymentConflictBody: "Оплата не подтверждена. Перечитайте заказ или повторите действие после проверки его актуального состояния.",
    paymentFailedTitle: "Оплата не выполнена",
    paymentFailedBody: "Сервис не подтвердил оплату. Проверьте актуальное состояние заказа.",
    paymentRetry: "Повторить оплату",
    openOrders: "Открыть мои заказы",
    expiredTitle: "Время черновика вышло",
    expiredBody: "Создайте новый черновик — устаревший заказ нельзя продолжить или восстановить локально.",
    createNew: "Создать новый черновик",
    blockersTitle: "Что ещё нужно сделать",
    blockers: {
      expert_required: "Выберите эксперта.",
      channel_unavailable: "Выбранный канал сейчас недоступен.",
      mode_required: "Выберите формат консультации.",
      slot_required: "Выберите доступное время.",
      duration_required: "Выберите длительность.",
      phone_verification_required: "Подтвердите телефон.",
      selection_unavailable: "Выбранная комбинация сейчас недоступна.",
      pricing_acknowledgement_required: "Подтвердите актуальную цену.",
      source_unavailable: "Один из источников временно недоступен.",
      submission_in_progress: "Заказ ещё создаётся.",
    },
    requestError: "Запрос не выполнен. Повторите попытку или перечитайте актуальный черновик.",
    sourceError: "Источник данных временно недоступен. Другие состояния мастера не подменяют этот ответ.",
    retrySource: "Повторить загрузку источника",
    timezoneMissing: "Для ранее созданного выбора нужно заново определить часовой пояс браузера и сохранить его в черновике.",
    restoreTimezone: "Определить часовой пояс и продолжить",
  },
  immediateCall: {
    cta: "Позвонить сейчас",
    hint: "Длительность и итоговую сумму рассчитает сервис по актуальным условиям.",
    submittingTitle: "Проверяем возможность звонка",
    submittingBody: "Сервис определяет доступное время, цену и состояние эксперта.",
    startedTitle: "Сессия звонка создана",
    startedBody: "Оплата подтверждена, а сессия передана в общий процесс соединения.",
    startingTitle: "Звонок запускается",
    startingBody: "Оплата подтверждена. Сервис продолжает запуск соединения.",
    awaitingTitle: "Оплачено, ожидаем эксперта",
    topUpTitle: "Нужно пополнить кошелёк",
    topUpBody: "Для звонка не хватает {{amount}}. После пополнения начните новую попытку.",
    openWallet: "Открыть кошелёк",
    rate: "Текущий тариф: {{amount}} за минуту",
    unavailableTitle: "Эксперт сейчас недоступен",
    bookingTitle: "У эксперта начинается консультация",
    bookingBody: "Попробуйте позвонить позже или выберите время через оформление консультации.",
    recoveryTitle: "Платёж ещё проверяется",
    recoveryBody: "Результат операции восстанавливается. Повторная проверка продолжит её без нового списания.",
    uncertainTitle: "Результат запроса неизвестен",
    uncertainBody: "Связь прервалась. Проверьте ту же операцию, чтобы не создавать повторное списание.",
    check: "Проверить операцию",
    compensatedTitle: "Оплата отменена",
    compensatedBody: "Денежный эффект компенсирован, заказ не создан. Новую попытку можно начать отдельно.",
    featureTitle: "Звонки временно недоступны",
    featureBody: "Сервис не может безопасно начать звонок. Попробуйте позже.",
    rateLimitedTitle: "Нужно немного подождать",
    rateLimited: {
      client: "Следующую попытку с этого аккаунта можно сделать после {{date}}.",
      expert: "Эксперту можно отправить следующий звонок после {{date}}.",
    },
    retryIn: "Повторить через {{count}} с",
    retry: "Позвонить ещё раз",
    duration: "Длительность",
    minutes: "{{count}} мин",
    rateLabel: "Тариф за минуту",
    total: "Итого",
    sessionCreated: "Сессия создана {{date}}",
    signIn: "Войти снова",
    awaitingReasons: {
      expert_offline: "Эксперт не в сети. Оплаченный заказ остаётся в очереди.",
      expert_busy: "Эксперт занят другим звонком. Оплаченный заказ остаётся в очереди.",
      booking_conflict: "У эксперта начинается консультация. Оплаченный заказ остаётся в очереди.",
      participant_unavailable: "Не удалось начать соединение с участником. Оплаченный заказ остаётся в очереди.",
      kyc_blocked: "Проверка допуска не разрешила звонок. Оплаченный заказ остаётся в очереди.",
    },
    unavailableReasons: {
      expert_offline: "Эксперт не в сети. Оплата и заказ не создавались.",
      expert_busy: "Эксперт занят другим звонком. Оплата и заказ не создавались.",
      kyc_blocked: "Проверка допуска не разрешила звонок. Оплата и заказ не создавались.",
    },
    errors: {
      invalid_immediate_call_request: {title: "Запрос отклонён", body: "Проверьте выбранного эксперта и повторите действие со страницы разговора."},
      authentication_required: {title: "Нужно войти снова", body: "Сессия завершилась. Войдите и повторите действие."},
      immediate_call_not_allowed: {title: "Звонок недоступен для аккаунта", body: "Текущая роль или состояние аккаунта не разрешает немедленный звонок."},
      idempotency_key_reused: {title: "Операция не совпала", body: "Защищённый ключ уже относится к другой попытке. Обновите страницу перед новым звонком."},
      immediate_call_dependency_unavailable: {title: "Один из сервисов не ответил", body: "Проверьте эту же операцию позже — её результат не подменяется новым запросом."},
      immediate_call_integrity_error: {title: "Результат нельзя подтвердить", body: "Сервис не вернул целостный результат. Проверьте эту же операцию позже."},
      network_error: {title: "Связь прервалась", body: "Результат запроса неизвестен. Проверьте эту же операцию, чтобы исключить повторное списание."},
      client_invalid_expert: {title: "Эксперт не выбран", body: "Откройте актуальный разговор с экспертом и повторите действие."},
      client_operation_pending: {title: "Уже есть незавершённый звонок", body: "Сначала вернитесь к ранее начатой попытке в исходном разговоре."},
      client_inconsistent_source: {title: "Получен некорректный ответ", body: "Данные не показаны частично. Проверьте эту же операцию позже."},
      unexpected: {title: "Не удалось выполнить запрос", body: "Проверьте эту же операцию позже или обратитесь в поддержку."},
    },
  },
  guestConsultation: {
    eyebrow: "Консультация без регистрации",
    skip: "Перейти к оформлению",
    loadingTitle: "Открываем заказ",
    loadingBody: "Проверяем защищённый доступ или создаём новое оформление.",
    loadErrorTitle: "Заказ не удалось открыть",
    loadErrorBody: "Ссылка недействительна либо сервис временно недоступен. Проверьте ссылку из письма и повторите попытку.",
    expires: "Данные оформления хранятся до {{date}}",
    cancel: "Отменить оформление",
    cancelledTitle: "Оформление отменено",
    cancelledBody: "Данные черновика удалены, ссылка доступа отозвана.",
    progressAria: "Шаги гостевого оформления",
    progress: {contact: "Контакты", selection: "Консультация", phone: "Телефон", review: "Проверка"},
    steps: {contact: "Укажите контакты", selection: "Выберите консультацию", phone: "Подтвердите телефон", review: "Проверьте заказ", submitted: "Заказ создан", unavailable: "Доступ закрыт"},
    contactTitle: "Как с вами связаться?",
    contactBody: "Имя, телефон и email нужны только для этого заказа. Телефон потребуется подтвердить перед отправкой.",
    noBirthDate: "Дата рождения для гостевого заказа не запрашивается.",
    saving: "Сохраняем…",
    continue: "Продолжить",
    selectionTitle: "Эксперт и длительность",
    selectionBody: "Гостевой MVP оформляет только голосовую консультацию без выбора времени. Длительности выданы сервисом и проверяются повторно.",
    phoneAccepted: "Телефон подтверждён для этого заказа.",
    reviewBody: "Цена и доступность будут проверены ещё раз. После создания заказа можно перейти к оплате.",
    contact: "Контакты",
    voiceUnscheduled: "Голосом, без расписания",
    editContact: "Изменить контакты",
    editSelection: "Изменить выбор",
    submittedTitle: "Заказ создан",
    paymentPending: "Заказ ожидает платёжный сценарий. Эта страница не показывает оплату успешной до подтверждения платёжного сервиса.",
    pay: "Оплатить заказ",
    goToPayment: "Перейти к оплате",
    paymentAmount: "Сумма оплаты",
    paymentProcessing: "Ожидаем подтверждение платежа. После оплаты вернитесь на эту страницу.",
    coverageProcessing: "Платёж подтверждён. Обновляем состояние заказа…",
    paymentFailed: "Платёж не выполнен. Обратитесь в поддержку с номером заказа.",
    remainingMinutes: "Осталось минут: {{count}}",
    expertCalls: "Эксперт позвонит на подтверждённый номер. Повторный звонок после обрыва инициирует эксперт.",
    manualRefund: "Для ручного возврата обратитесь в поддержку и укажите номер заказа. Возврат не выполняется автоматически.",
    orderStates: {awaiting_payment:"Ожидает оплаты",paid:"Заказ оплачен",expert_invited:"Соединяем с экспертом",in_progress:"Идёт консультация",completed:"Консультация завершена",cancelled:"Заказ отменён"},
    accessByEmail: "Ссылка из письма возвращает только к этому заказу и не создаёт аккаунт.",
    notices: {
      feature_unavailable: "Выбранная комбинация сейчас недоступна. Измените эксперта или длительность.",
      pricing_changed: "Цена изменилась. Проверьте новую сумму и подтвердите отправку ещё раз.",
    },
    conflict: "Заказ уже изменился в другой вкладке. Перечитайте актуальное состояние перед новым действием.",
    requestError: "Запрос не выполнен. Повторите попытку после загрузки актуального состояния.",
    reload: "Перечитать заказ",
    unavailableTitle: "Доступ к заказу закрыт",
    unavailableBody: "Заказ анонимизирован или ссылка доступа отозвана.",
  },
  cabinet: {
    skipToContent: "Перейти к содержимому",
    homeAria: "Главная страница личного кабинета",
    brandSubtitle: "Личный кабинет",
    openAdmin: "Админка",
    openExpert: "Кабинет эксперта",
    accountId: "Аккаунт · ID {{id}}",
    navigationAria: "Разделы личного кабинета",
    breadcrumbAria: "Хлебные крошки",
    navigation: {
      overview: "Обзор",
      consultation: "Новая консультация",
      dialogs: "Сообщения",
      orders: "Мои заказы",
      reviews: "Мои отзывы",
      wallet: "Кошелёк",
      profile: "Мой профиль",
      favorites: "Избранное",
      notifications: "Уведомления",
      support: "Поддержка",
      deleteAccount: "Удалить аккаунт",
    },
    routeLoading: "Загружаем раздел…",
    routeErrorTitle: "Раздел не удалось отобразить",
    routeErrorBody: "Перезагрузите страницу. Если ошибка повторится, передайте номер обращения в поддержку.",
    notFoundTitle: "Такого раздела нет",
    notFoundBody: "Проверьте адрес или вернитесь к обзору личного кабинета.",
    backToOverview: "Вернуться к обзору",
    review: {
      badge: "Режим макета",
      scenario: "Состояние для ревью",
      panelAria: "Настройка демонстрационных состояний",
      panelTitle: "Независимые состояния секций",
      scenarios: {
        normal: "Данные загружены",
        empty: "Пусто",
        error: "Сервис недоступен",
        loading: "Загрузка",
        long: "Длинный текст",
        no_avatar: "Без аватара",
        multi_currency: "Несколько валют",
        blocked: "Удаление заблокировано",
      },
      sources: {profile: "Профиль", wallet: "Кошелёк", orders: "Заказы", dialogs: "Диалоги"},
    },
    states: {
      unavailableTitle: "Раздел временно недоступен",
      unavailableBody: "Данные не подменяются нулями или примерами. Повторите запрос позже.",
      waitingForApi: "Действие станет доступно после подключения API сервиса-владельца.",
    },
    filters: {lastThirtyDays: "Последние 30 дней", allHistory: "Вся история"},
    overview: {
      eyebrow: "Личный кабинет",
      lead: "Здесь собраны профиль, деньги, ближайшие консультации и новые сообщения.",
      openProfile: "Открыть профиль",
      sectionsAria: "Сводка личного кабинета",
      profileTitle: "Профиль",
      walletTitle: "Кошелёк",
      ordersTitle: "Ближайшие консультации",
      dialogsTitle: "Новые сообщения",
      details: "Подробнее",
      allOrders: "Все заказы",
      allDialogs: "Все сообщения",
    },
    profile: {
      eyebrow: "Аккаунт",
      title: "Мой профиль",
      lead: "Основные данные Account и единый аватар для пользовательской и экспертной ролей.",
      loading: "Загружаем профиль",
      avatarTitle: "Аватар аккаунта",
      avatarBody: "JPG, PNG или GIF до 5 МБ. Финальную проверку и оптимизацию выполняет Media.",
      changeAvatar: "Изменить аватар",
      clearAvatar: "Убрать аватар",
      clearingAvatar: "Убираем аватар…",
      uploadProgress: "Загружено {{percent}}%",
      avatarRetry: "Не удалось завершить загрузку. Повторите с тем же файлом.",
      avatarSaved: "Аватар обновлён.",
      avatarRetention: "Замена и очистка не удаляют предыдущий media-файл автоматически.",
      avatarErrors: {
        mime: "Выберите изображение JPEG, PNG или GIF.",
        size: "Размер изображения должен быть не больше 5 МБ.",
        upload: "Не удалось загрузить или прикрепить аватар.",
      },
      dataEyebrow: "Личные данные",
      dataTitle: "Основная информация",
      ownerData: "Только владелец",
      firstName: "Имя",
      lastName: "Фамилия",
      birthDate: "Дата рождения",
      email: "Email",
      phone: "Телефон",
      addPhone: "Добавить телефон",
      changePhone: "Изменить телефон",
      cancelPhone: "Закрыть подтверждение",
      phoneSaved: "Телефон подтверждён и обновлён.",
      phoneConfirmedRefreshing: "Обновляем профиль и текущую сессию.",
      verified: "Подтверждён",
      notVerified: "Не подтверждён",
      notSpecified: "Не указан",
      confirmEmail: "Подтвердить email",
      requestingEmail: "Запрашиваем ссылку…",
      resendEmail: "Отправить ссылку ещё раз",
      resendEmailIn: "Повторно через {{seconds}} сек.",
      emailVerificationAccepted: "Новое письмо отправляется на {{email}}. Используйте только последнюю ссылку.",
      emailVerificationRateLimited: "Лимит отправок исчерпан. Повторите позже.",
      emailVerificationUnavailable: "Не удалось запросить новую ссылку. Повторите попытку.",
      emailVerificationStale: "Email уже изменился или подтверждён. Перечитайте профиль.",
      criticalTitle: "Подтверждённые данные защищены",
      criticalBody: "Email, телефон и подтверждённые ФИО изменяются через повторную верификацию или поддержку.",
      phoneRecoveryHelp: "Если вход и прежний номер недоступны, обратитесь в поддержку через действующий внешний канал. Оператор выберет способ проверки права на аккаунт; новый номер вы подтвердите кодом из SMS.",
      changeContact: "Изменить через поддержку",
      save: "Сохранить изменения",
      saving: "Сохраняем…",
      saved: "Изменения сохранены.",
      saveError: "Не удалось сохранить профиль. Проверьте поля и повторите попытку.",
      staleBody: "Профиль уже изменён в другой вкладке. Перечитайте актуальные данные перед повторной попыткой.",
      reload: "Перечитать профиль",
      contactSupport: "Обратиться в поддержку",
      securityEyebrow: "Безопасность",
      passwordTitle: "Пароль",
      passwordBody: "После безопасной смены пароля активные браузерные сессии будут завершены.",
      changePassword: "Изменить пароль",
      currentPassword: "Текущий пароль",
      newPassword: "Новый пароль",
      confirmPassword: "Повторите новый пароль",
      confirmPasswordChange: "Сменить пароль",
      changingPassword: "Меняем пароль…",
      cancelPassword: "Отмена",
      passwordMismatch: "Новые пароли не совпадают. Поля очищены.",
      passwordError: "Пароль не изменён. Проверьте текущий пароль и требования к новому. Поля очищены.",
    },
    wallet: {
      eyebrow: "Финансы",
      title: "Кошелёк",
      lead: "Баланс, неизменяемая история операций и состояния пополнений из сервисов-владельцев.",
      loading: "Загружаем кошелёк",
      balancesAria: "Баланс кошелька",
      available: "Доступно",
      balance: "Баланс",
      walletCurrency: "Баланс",
      emptyTitle: "Кошелёк пока пуст",
      emptyBalances: "Баланс появится после первой подтверждённой денежной операции.",
      topupEyebrow: "Пополнение",
      topupTitle: "Пополнить кошелёк",
      topupBody: "Выберите валюту и способ оплаты. Перед подтверждением покажем курс и сумму зачисления.",
      loadingOptions: "Загружаем способы пополнения",
      loadingLedger: "Загружаем операции",
      loadingPayments: "Загружаем пополнения",
      loadingPayment: "Проверяем состояние платежа",
      noWallet: "Баланс появится после первой операции",
      lagging: "Данные обновляются",
      currency: "Валюта",
      method: "Способ оплаты",
      chooseCurrency: "Выберите валюту",
      chooseMethod: "Выберите способ оплаты",
      period: "Период",
      visibility: "Видимость",
      visible: "Показанные",
      hidden: "Скрытые",
      lastThirtyDays: "Последние 30 дней",
      allHistory: "Вся история",
      minimum: "Минимум: {{amount}}",
      optionUnavailable: "Пополнение в этой валюте сейчас недоступно.",
      belowMinimum: "Сумма ниже установленного минимума.",
      invalidAmount: "Введите положительную сумму с двумя знаками после запятой.",
      creating: "Создаём платёж…",
      requestFailed: "Не удалось выполнить действие. Обновите данные и повторите попытку.",
      paymentStatusTitle: "Состояние пополнения",
      paymentStatusLead: "Зачисление подтверждает сервер. Возврат со страницы оплаты сам по себе не означает успех.",
      continuePayment: "Продолжить оплату",
      refreshStatus: "Проверить статус",
      backToWallet: "К кошельку",
      details: "Статус",
      retryPayment: "Повторить оплату",
      hide: "Скрыть",
      restore: "Восстановить",
      previous: "Назад",
      next: "Далее",
      statuses: {
        confirmation_required: "Ожидает оплаты",
        payment_processing: "Платёж обрабатывается",
        failed: "Платёж не выполнен",
        credit_pending: "Платёж принят, ждём зачисления",
        credited: "Зачислено",
      },
      statusBodies: {
        confirmation_required: "Откройте защищённую страницу оплаты и затем вернитесь проверить состояние.",
        payment_processing: "Проверяем подтверждение от платёжного провайдера.",
        failed: "Оплата не прошла. При доступном действии её можно повторить из истории.",
        credit_pending: "Провайдер подтвердил оплату, но кошелёк ещё не зачислен.",
        credited: "Средства подтверждённо зачислены в кошелёк.",
      },
      operations: {
        consultation: "Консультация", service: "Услуга", invoice: "Счёт", transfer: "Перевод", answer: "Ответ",
        refund: "Возврат", adjustment: "Корректировка", payout: "Выплата", earning: "Начисление",
        opening_balance: "Начальный баланс", payment_top_up: "Пополнение", other: "Операция",
      },
      amount: "Сумма",
      topup: "Подтвердить и перейти к оплате",
      preview: "Рассчитать пополнение",
      calculating: "Рассчитываем…",
      conversionRate: "Курс: 1 {{currency}} = {{rate}} RUB",
      creditAmount: "Зачисление: {{amount}}",
      paymentAmount: "Оплата: {{amount}}",
      originalAmount: "Исходная сумма: {{amount}}",
      sourceAmountLabel: "Исходная сумма",
      rateLabel: "Курс",
      debitAmount: "Списание: {{amount}}",
      rateChanged: "Курс изменился. Проверьте новую сумму зачисления и подтвердите оплату.",
      ledgerEyebrow: "Ledger",
      ledgerTitle: "Операции",
      paymentsEyebrow: "Payments",
      paymentsTitle: "Пополнения",
      noOperationsTitle: "Операций пока нет",
      noOperationsBody: "Здесь появится неизменяемая финансовая история.",
      noPaymentsTitle: "Пополнений пока нет",
      noPaymentsBody: "Попытки оплаты появятся отдельно от ledger-операций.",
      paymentStates: {pending: "В обработке", succeeded: "Зачислено", failed: "Неуспешно"},
    },
    orders: {
      eyebrow: "Консультации",
      title: "Мои заказы",
      lead: "Условия заказа неизменяемы, а доступные действия определяет сервис Consultations.",
      filtersAria: "Фильтры истории заказов",
      serverFilterNote: "Фильтр применяется сервером до пагинации",
      loading: "Загружаем заказы",
      emptyTitle: "Заказов пока нет",
      emptyBody: "После оформления консультации она появится в этом разделе.",
      orderId: "Заказ {{id}}",
      date: "Дата и время",
      price: "Стоимость",
      duration: "Оплачено",
      remaining: "Осталось",
      minutes: "{{count}} мин",
      openDialog: "Открыть диалог",
      continueCall: "Продолжить звонок",
      requestRefund: "Запросить возврат",
      actionsNote: "Действия появятся только при подтверждённом server capability.",
      states: {awaiting_payment: "Ожидает оплаты", paid: "Оплачен", in_progress: "Идёт консультация", completed: "Завершён", cancelled: "Отменён"},
    },
    dialogs: {
      eyebrow: "Общение",
      title: "Мои сообщения",
      lead: "История хранится в Chat, а WebSocket сообщает, когда её нужно перечитать.",
      loading: "Загружаем диалоги",
      emptyTitle: "Диалогов пока нет",
      emptyBody: "Здесь появятся переписки с экспертами и поддержкой.",
      openSupport: "Написать в поддержку",
      openingSupport: "Открываем диалог с поддержкой",
      listAria: "Список диалогов",
      avatar: "Аватар: {{name}}",
      presence: {online: "На линии", busy: "Занят", offline: "Не в сети"},
      presenceUnavailable: "Статус временно недоступен",
      supportPeer: "Единый диалог с поддержкой",
      unread: "Непрочитанных сообщений: {{count}}",
      unreadUnavailable: "Счётчик непрочитанных временно недоступен",
      previewAttachment: "Вложение",
      previewEmpty: "Сообщений пока нет",
      threadEyebrow: "Диалог",
      threadTitle: "Переписка",
      threadLead: "Новые сообщения и пропуски после reconnect догружаются из сохранённой истории.",
      loadingThread: "Загружаем переписку",
      messagesAria: "История сообщений",
      loadOlder: "Показать предыдущие сообщения",
      loadingOlder: "Загружаем предыдущие…",
      loadMore: "Показать ещё",
      loadingMore: "Загружаем…",
      loadMoreFailed: "Не удалось загрузить следующую страницу. Повторите попытку.",
      messageLabel: "Сообщение",
      messagePlaceholder: "Напишите сообщение…",
      send: "Отправить",
      sending: "Отправляем…",
      attach: "Прикрепить файл",
      uploadProgress: "Загружено: {{percent}}%",
      attachment: "Вложение",
      attachmentPending: "Доступ к вложению ещё готовится.",
      attachmentUnavailable: "Вложение временно недоступно.",
      close: "Закрыть диалог",
      reopen: "Открыть снова",
      transfer: "Отправить перевод",
      amountMinor: "Сумма в минимальных единицах",
      currency: "Валюта",
      sendTransfer: "Подтвердить перевод",
      payInvoice: "Оплатить счёт",
      systemMessageAria: "Системное сообщение",
      actionFailed: "Действие не выполнено. Актуальная история сохранена; повторите попытку.",
      fileErrors: {mime: "Этот тип файла не поддерживается.", size: "Размер файла должен быть от 1 байта до 10 МБ."},
      capabilityReasons: {
        participant_closed: "Собеседник закрыл свою сторону диалога.",
        current_role_required: "Действие недоступно для вашей роли.",
        feature_disabled: "Функция сейчас выключена.",
        not_applicable: "Действие неприменимо к этому диалогу.",
        terminal: "Диалог завершён.",
        source_unavailable: "Возможность отправки временно не подтверждена сервером.",
      },
      system: {
        payment: {succeeded: "Платёж выполнен"},
        invoice: {issued: "Выставлен счёт", paid: "Счёт оплачен"},
        transfer: {sent: "Перевод отправлен"},
        consultation: {ordered: "Консультация заказана", started: "Консультация началась", completed: "Консультация завершена", cancelled: "Консультация отменена"},
        review: {published: "Эксперт ответил на отзыв", repliedAt: "Ответ опубликован {{date}}"},
      },
    },
    support: {
      eyebrow: "Помощь",
      title: "Поддержка Magistika",
      lead: "Обращение использует обычный реальный dialog с участником роли support.",
    },
    delete: {
      eyebrow: "Управление аккаунтом",
      title: "Удаление аккаунта",
      lead: "Перед подтверждением проверим баланс, заказы, брони и выплаты.",
      loading: "Проверяем возможность удаления",
      warningTitle: "Это необратимое действие",
      warningBody: "После окончательной проверки профиль будет необратимо анонимизирован. Если есть незавершённые обязательства, аккаунт останется активным.",
      effects: {
        profile: "Email и телефон освобождаются, вход и восстановление становятся невозможны.",
        history: "История платежей, заказы, сообщения и записи действий сохраняются без действующего профиля.",
        sessions: "Все сессии аккаунта и входы от его имени завершаются.",
        kyc: "Верификационные документы сохраняются по правилам хранения, а доступ к ним через удалённый аккаунт закрывается.",
      },
      rulesTitle: "Правила удаления аккаунта",
      contactKind: "Подтверждающий контакт", phone: "Телефон",
      actions: {wallet: "Открыть кошелёк", orders: "Открыть заказы", support: "Открыть поддержку", retry: "Повторить проверку"},
      retryCheck: "Повторить проверку", checkStatus: "Проверить статус",
      processingTitle: "Проверяем результат удаления", processingBody: "Подтверждение отправляется или обрабатывается. При потере ответа результат можно восстановить в этом браузере. Повторно отправлять контакт не нужно.",
      completedTitle: "Аккаунт удалён", completedBody: "Профиль анонимизирован, прежние сессии завершены. Контакт освобождён. История обязательств сохраняется по правилам сервиса.",
      retryableTitle: "Удаление можно повторить", retryableBody: "Аккаунт остаётся активным. Вернитесь в кабинет и начните новую проверку.",
      invalidTitle: "Подтверждение не принято", invalidBody: "Проверьте подтверждённый email или телефон и начните новую проверку в кабинете.",
      missingTitle: "Результат удаления недоступен", missingBody: "В этом браузере нет действующего подтверждения. Проверьте возможность входа или обратитесь по публичному контакту поддержки. Правила удаления приведены ниже.",
      returnCabinet: "Вернуться в кабинет", signIn: "Перейти ко входу", returnHome: "На главную",
      previewEyebrow: "Предварительная проверка",
      blockedTitle: "Сначала завершите обязательства",
      blockedBody: "Аккаунт остаётся активным. Перейдите в нужный раздел и повторите удаление после урегулирования.",
      readyTitle: "Удаление можно подтвердить",
      readyBody: "При подтверждении все владельцы повторно проверят актуальное состояние.",
      openConfirm: "Перейти к подтверждению",
      closeDialog: "Закрыть окно подтверждения",
      confirmEyebrow: "Финальное подтверждение",
      confirmTitle: "Удалить аккаунт?",
      confirmBody: "Введите собственный email или телефон. Контакт используется только для проверки и не сохраняется в форме.",
      confirmLabel: "Email или телефон аккаунта",
      confirmBlocked: "Подтверждение недоступно, пока существуют блокирующие обязательства.",
      cancel: "Отмена",
      confirm: "Удалить аккаунт",
      blockers: {
        wallet_balance_non_zero: {title: "На кошельке есть остаток", body: "Деньги нельзя сжечь или перенести автоматически.", action: "Открыть кошелёк"},
        wallet_hold_active: {title: "Есть зарезервированные средства", body: "Дождитесь завершения или отмены связанного обязательства.", action: "Открыть кошелёк"},
        financial_settlement_pending: {title: "Расчёты ещё не завершены", body: "Дождитесь завершения расчётов и повторите проверку.", action: "Повторить проверку"},
        payment_pending: {title: "Есть незавершённый платёж", body: "Проверьте результат платежа в кошельке.", action: "Открыть кошелёк"},
        booking_active: {title: "Есть активная бронь", body: "Завершите или отмените бронь по правилам сервиса.", action: "Открыть заказы"},
        payout_pending: {title: "Ожидается выплата", body: "Дождитесь завершения выплаты или обратитесь в поддержку.", action: "Открыть поддержку"},
        consultation_order_active: {title: "Есть активная консультация", body: "Завершите или отмените заказ по правилам сервиса.", action: "Открыть заказы"},
        owner_unavailable: {title: "Проверка временно недоступна", body: "Повторите позже или обратитесь в поддержку.", action: "Открыть поддержку"},
      },
    },
  },
  expertCabinet: {
    skipToContent: "Перейти к содержимому",
    homeAria: "Главная страница кабинета эксперта",
    brandSubtitle: "Кабинет эксперта",
    accountId: "Эксперт · ID {{id}}",
    openUser: "Личный кабинет",
    navigationAria: "Разделы кабинета эксперта",
    breadcrumbAria: "Хлебные крошки",
    navigation: {overview: "Обзор", dialogs: "Сообщения", orders: "Заказы", reviews: "Отзывы", schedule: "Расписание", earnings: "Доходы", articles: "Статьи", profile: "Профиль эксперта", favorites: "Избранное", notifications: "Уведомления", kyc: "Верификация", support: "Поддержка"},
    routeLoading: "Загружаем раздел эксперта…",
    routeErrorTitle: "Экран эксперта не удалось отобразить",
    routeErrorBody: "Перезагрузите страницу. Если ошибка повторится, передайте номер обращения в поддержку.",
    forbiddenTitle: "Нет роли эксперта",
    forbiddenBody: "Этот раздел доступен только аккаунтам с активной ролью эксперта.",
    notFoundTitle: "Такого раздела нет",
    notFoundBody: "Проверьте адрес или вернитесь к обзору кабинета эксперта.",
    backToOverview: "Вернуться к обзору",
    common: {none: "Нет данных", details: "Подробнее", loading: "Загружаем данные", save: "Сохранить", close: "Закрыть окно", cancel: "Отмена", confirm: "Подтвердить"},
    presence: {
      label: "Статус доступности", online: "На линии", busy: "Занят", offline: "Не в сети", unavailable: "Статус временно недоступен",
      actionsAria: "Изменить статус доступности", goOnline: "Онлайн", goOffline: "Офлайн", reload: "Обновить",
    },
    review: {
      badge: "Режим макета",
      scenario: "Состояние для ревью",
      panelAria: "Настройка демонстрационных состояний эксперта",
      panelTitle: "Независимые состояния секций",
      scenarios: {normal: "Данные загружены", empty: "Пусто", error: "Сервис недоступен", loading: "Загрузка", long: "Длинный текст", conflict: "Конфликт версии", draft: "Черновик", hidden: "Скрыт", inactive: "Неактивные специализации", busy: "Занят", offline: "Не в сети", multi_currency: "Несколько валют", submitted: "На проверке", approved: "Одобрено", rejected: "Отклонено"},
      sources: {profile: "Профиль", presence: "Доступность", schedule: "Расписание", orders: "Заказы", dialogs: "Диалоги", earnings: "Доходы", articles: "Статьи", kyc: "KYC"},
    },
    states: {
      unavailableTitle: "Раздел временно недоступен",
      unavailableBody: "Данные не подменяются нулями или примерами. Повторите запрос позже.",
      conflictTitle: "Данные уже изменились",
      conflictBody: "Обновите состояние и повторите действие с актуальной версией.",
      waitingForApi: "Изменение станет доступно после подключения API сервиса-владельца.",
    },
    overview: {
      eyebrow: "Рабочее пространство", title: "Здравствуйте, {{name}}", lead: "Профиль, рабочее время, консультации, сообщения и начисления собраны в независимых секциях.", openSchedule: "Настроить расписание", sectionsAria: "Сводка кабинета эксперта",
      profile: "Профиль", schedule: "Расписание", orders: "Активные заказы", dialogs: "Сообщения", earnings: "Доступно", articles: "Статьи", kyc: "Верификация", freeSlots: "свободных слотов", activeOrders: "оплачено или в работе", unread: "непрочитанных", materials: "материалов",
    },
    profile: {
      eyebrow: "Публичная карточка", title: "Профиль эксперта", lead: "Описание, специализации и видимость публичной карточки отделены от данных общего аккаунта.", loading: "Загружаем профиль эксперта",
      lifecycle: {draft: "Черновик", published: "Опубликован", hidden: "Скрыт"},
      visibility: {listed: "Виден в каталоге", direct_link: "Только по прямой ссылке", hidden: "Скрыт полностью"},
      visibilityLabel: "Видимость карточки", shortCounter: "{{count}} из 500 символов", detailCounter: "{{count}} из 65536 байт",
      shortDescription: "Короткое описание", detailedDescription: "Подробное описание", specializations: "Специализации", inactiveSpecialization: "Неактивна в каталоге", hideGeneralServices: "Скрыть общие услуги", hideCallButton: "Скрыть кнопку звонка", sectionsAria: "Разделы профиля эксперта",
      previewAria: "Предпросмотр подробного описания", preview: "Предпросмотр Markdown", previewEmpty: "Добавьте подробное описание, чтобы увидеть предпросмотр.",
      validation: {short_description: "Короткое описание не должно превышать 500 символов.", detailed_description: "Подробное описание не должно превышать 65536 байт.", markdown: "Описание содержит неподдерживаемую Markdown-разметку или небезопасную ссылку."},
      saveError: "Профиль не удалось сохранить. Повторите попытку.", staleBody: "Профиль уже изменён. Перечитайте актуальные данные перед повторной отправкой.", reload: "Перечитать профиль", saved: "Профиль сохранён.", saving: "Сохраняем…",
      tabs: {profile: "Профиль", audio: "Аудиовизитка", requisites: "Реквизиты", account: "Данные аккаунта"},
    },
    tariff: {eyebrow: "Тариф", title: "Стоимость консультации", loading: "Загружаем тариф", notConfigured: "Тариф пока не настроен", readOnly: "Изменение тарифа выполняет поддержка. Здесь показано авторитетное значение сервера.", contactSupport: "Написать в поддержку"},
    audio: {
      title: "Аудиовизитка", lead: "Короткая запись помогает клиенту услышать эксперта до консультации.", loading: "Загружаем аудиовизитку", recordingReady: "Запись опубликована", noRecording: "Записи пока нет", duration: "Длительность: {{seconds}} сек.", emptyBody: "Загрузите MP3-запись длительностью до 60 секунд.", unsupported: "Браузер не поддерживает воспроизведение аудио.", constraints: "MP3, от 1 байта до 10 МиБ, не длиннее 60 секунд.", selected: "Выбран файл: {{name}}", progress: "Загружено {{percent}}%", uploadError: "Аудиозапись не удалось загрузить. Повторите попытку.", playbackError: "Ссылку на аудиозапись не удалось обновить. Повторите попытку.", clearError: "Аудиозапись не удалось удалить. Повторите попытку.", saved: "Аудиовизитка обновлена.", validation: {audio_mime: "Выберите MP3-файл.", audio_size: "Размер MP3 должен быть от 1 байта до 10 МиБ."}, upload: "Загрузить запись", delete: "Удалить запись",
    },
    requisites: {
      title: "Платёжные реквизиты", lead: "Приватное значение доступно только владельцу и не сохраняется в браузере.", loading: "Проверяем состояние реквизитов", configured: "Реквизиты настроены", notConfigured: "Реквизиты не настроены", privateNote: "Введите реквизиты единым непрозрачным значением. После сохранения форма очищается и сервер не возвращает значение в mutation-response.", value: "Приватные реквизиты", fixtureRedacted: "Значение скрыто в демонстрационном контуре", counter: "{{count}} из 4096 байт", validation: "Реквизиты должны занимать от 1 до 4096 байт.", saveError: "Реквизиты не удалось сохранить. Повторите попытку.", savedNoEcho: "Реквизиты обновлены. Сохранённое значение не отображается повторно.", clear: "Очистить реквизиты",
    },
    schedule: {
      eyebrow: "Рабочее время", title: "Расписание", lead: "Календарь показывает правила доступности, исключения и уже занятые интервалы в часовом поясе эксперта.", loading: "Загружаем расписание", emptyTitle: "Рабочее время не настроено", emptyBody: "Добавьте повторяющееся правило или отдельное исключение.",
      viewAria: "Режим календаря", day: "День", week: "Неделя", previous: "Предыдущий период", next: "Следующий период", today: "Сегодня",
      accepting: "Новые заказы открыты", closed: "Новые заказы закрыты", alwaysOn: "Постоянная доступность",
      saved: "Расписание обновлено.", conflict: "Расписание уже изменилось. Перечитайте актуальную версию.", mutationFailed: "Не удалось изменить расписание. Повторите попытку.", reload: "Перечитать",
      slotStates: {free: "Свободно", reserved: "Забронировано", unavailable: "Недоступно"},
      bookingStates: {reserved: "Ожидает оплаты", confirmed: "Подтверждено", expired: "Истекло", cancelled: "Отменено", consumed: "Проведено", consumed_no_show: "Неявка"},
      bookingRef: "Бронь {{id}}", editOccurrence: "Изменить этот слот", cancelOccurrence: "Отменить этот слот",
      dstIssues: {nonexistent_local_time: "Такого локального времени не существует", ambiguous_local_time: "Локальное время неоднозначно"},
      dstWarning: "Marketplace вернул DST-проблемы: {{count}}. Они не превращены браузером в слоты.",
      settingsEyebrow: "Режим работы", settingsTitle: "Доступность и приём заказов", alwaysOnLabel: "Постоянная доступность", alwaysOnHelp: "Не меняет online presence; исключения и брони остаются приоритетнее.", acceptingLabel: "Принимать новые заказы", acceptingHelp: "Отключение закрывает расписание и CTA бронирования, но не скрывает карточку.", makeStandard: "Сделать эту неделю стандартной",
      rulesEyebrow: "Повторение", rulesTitle: "Правила доступности", noRules: "Правил пока нет.", edit: "Изменить", delete: "Удалить", endFromDate: "Завершить с начала периода", cancelSeries: "Отменить всю серию",
      exceptionsEyebrow: "Точечные изменения", exceptionsTitle: "Исключения", noExceptions: "Исключений пока нет.",
      exceptionKinds: {break: "Перерыв", day_off: "Нерабочий день", vacation: "Отпуск", holiday: "Праздник", cancelled_occurrence: "Отменённый слот"},
      editorEyebrow: "Правило", editorTitle: "Добавить рабочие часы", editRuleTitle: "Изменить правило", ruleKind: "Тип правила", recurring: "Повторяющееся", oneOff: "Разовый слот", date: "Дата", from: "С", to: "До", addRule: "Добавить правило",
      recurrence: "Повторение", frequency: "Частота", weekly: "Еженедельно", daily: "Ежедневно", interval: "Интервал", startDate: "Дата начала", endDate: "Дата окончания",
      weekdays: {monday: "Пн", tuesday: "Вт", wednesday: "Ср", thursday: "Чт", friday: "Пт", saturday: "Сб", sunday: "Вс"},
      oneOffOn: "Разовый слот · {{date}}", everyDays: "Каждые {{count}} дн.", everyWeeks: "Каждые {{count}} нед.",
      occurrenceEyebrow: "Один occurrence", occurrenceTitle: "Изменить слот {{date}}",
      exceptionEditorEyebrow: "Исключение", exceptionEditorTitle: "Добавить перерыв или нерабочий период", exceptionKind: "Тип исключения", allDay: "Весь день", addException: "Добавить исключение",
      timezoneEyebrow: "Часовой пояс", timezoneTitle: "Предпросмотр смены зоны", timezoneHelp: "Сначала Marketplace сравнит интервалы и покажет затронутые брони. Браузер не пересчитывает правила самостоятельно.", timezone: "IANA timezone",
      preview: "Предпросмотр", previewing: "Сравниваем…", previewFailed: "Не удалось получить предпросмотр.", previewOutcomes: {no_impact: "Изменений интервалов нет", impact: "Интервалы изменятся"}, previewSummary: "Изменений: {{impacts}}, затронутых броней: {{bookings}}", changeTimezone: "Сменить часовой пояс",
      confirmOccurrence: "Отменить только этот слот?", confirmRule: "Удалить разовое правило?", confirmSeries: "Отменить всю серию?", confirmSeriesTail: "Завершить серию с начала показанного периода?", confirmStandard: "Заменить правила расписанием текущей недели?",
    },
    orders: {
      eyebrow: "Консультации", title: "Заказы", lead: "Очередность, состояние и доступные действия определяет сервис Consultations.", loading: "Загружаем очередь", emptyTitle: "Очередь пуста", emptyBody: "Новые оплаченные консультации появятся здесь.",
      filters: {aria: "Фильтры очереди консультаций", state: "Состояние", source: "Источник", all: "Все"},
      orderId: "Заказ {{id}}", when: "Дата и время", price: "Стоимость", time: "Время", remaining: "{{remaining}} из {{total}} мин", remainingPending: "Остаток уточняется", details: "Подробнее",
      call: "Начать звонок", cancel: "Отменить с полным возвратом", states: {waiting: "Ожидает", active: "Активный звонок", recovery_pending: "Восстановление расчёта"},
      sources: {unscheduled: "Без записи", booking: "По записи", unscheduled_draft: "Без записи", unscheduled_guest: "Гостевой заказ", immediate: "Немедленный звонок"},
      callStates: {created: "Звонок создаётся", ringing_expert: "Вызов эксперта", ringing_client: "Вызов клиента", connected: "Соединение установлено", finished: "Звонок завершён", failed: "Звонок прерван"},
      latestCall: "Последняя попытка: {{state}}, {{date}}", billedMinutes: "Списано минут: {{count}}", attempts_one: "Попытка звонка: {{count}}", attempts_few: "Попытки звонка: {{count}}", attempts_many: "Попыток звонка: {{count}}", attempts_other: "Попыток звонка: {{count}}", noAttempts: "Попыток звонка ещё не было.", earlierCalls: "Показаны последние 20 попыток; более ранние доступны в полном журнале.",
      blockReasons: {
        feature_disabled: "Действие временно выключено.", active_call: "Уже есть активный звонок.", recovery_pending: "Сначала должен завершиться расчёт предыдущего звонка.", no_remaining: "Оплаченное время исчерпано.", scheduled_not_started: "Запись начнётся {{date}}.", scheduled_elapsed: "Интервал записи уже завершён.", expert_busy: "Эксперт уже занят другим звонком.", kyc_unavailable: "Проверка допуска к звонкам временно недоступна.", cooldown_active: "Повторный звонок станет доступен {{date}}.", projection_stale: "Очередь ещё догоняет актуальное состояние.",
      },
      projectionStale: "Очередь обновляется. Действия временно закрыты сервером.", refreshFailed: "Не удалось перечитать очередь.", queueChanged: "Очередь изменилась во время просмотра и была перечитана с первой страницы.", loadMore: "Показать ещё", loadingMore: "Загружаем…", loadMoreFailed: "Не удалось загрузить следующую страницу.", detailFailed: "Не удалось открыть подробности консультации.", mutationFailed: "Действие не выполнено. Перечитайте очередь и повторите попытку.", submitting: "Отправляем…",
      confirmEyebrow: "Требуется подтверждение", cancelTitle: "Отменить консультацию?", cancelBody: "Заказ {{id}}, клиент {{name}}. Сервер повторно проверит право на полный возврат; зачисление может завершиться позже.", callTitle: "Начать консультацию?", callBody: "Будет запущен звонок по заказу {{id}} с клиентом {{name}}.",
      callOutcomes: {pending: "Запуск звонка принят. Очередь перечитана.", replayed: "Результат запуска уже был сохранён. Очередь перечитана."}, cancelled: "Консультация отменена. Возврат {{amount}} передан в обработку.",
      detailEyebrow: "Подробности консультации", suggestionEyebrow: "Эксперт снова на линии", suggestionTitle: "Начать следующую консультацию?", suggestionBody: "Сервер предлагает позвонить клиенту {{name}}. Звонок начнётся только после подтверждения.", suggestionDismiss: "Не сейчас", suggestionAccept: "Перейти к звонку",
    },
    dialogs: {
      eyebrow: "Общение", title: "Сообщения", lead: "Поддержка закреплена первой, непрочитанные сообщения и статус собеседника видны независимо от заказов.", loading: "Загружаем диалоги", emptyTitle: "Диалогов пока нет", emptyBody: "Диалоги с клиентами появятся после создания консультации.", openSupport: "Написать в поддержку", unread: "Непрочитанных: {{count}}", threadEyebrow: "Диалог с клиентом", threadTitle: "Переписка", threadLead: "История загружается из Chat; WebSocket приносит только новые события.", loadingThread: "Загружаем переписку", back: "К диалогам", messagesAria: "История сообщений", messageLabel: "Сообщение", placeholder: "Напишите сообщение…", invoice: "Выставить счёт", send: "Отправить", invoiceEyebrow: "Новый счёт", invoiceTitle: "Выставить счёт клиенту", invoiceAmount: "Сумма", invoiceComment: "Комментарий", invoiceSend: "Отправить счёт",
    },
    support: {eyebrow: "Помощь", title: "Поддержка Magistika", lead: "Обращение использует обычный диалог с участником роли support."},
    earnings: {
      eyebrow: "Финансы", title: "Доходы", lead: "Общий баланс и история операций. Для начислений сохраняются исходная сумма услуги и курс.", loading: "Загружаем доходы", balancesAria: "Доступные суммы эксперта", available: "Доступно", emptyTitle: "Начислений пока нет", emptyBody: "Баланс появится после первой завершённой консультации.", accruals: "История начислений", operation: "Операция", date: "Дата", amount: "Сумма", sourceTypes: {consultation: "Консультация", adjustment: "Корректировка"}, noAccrualsTitle: "История пуста", noAccrualsBody: "Подтверждённые начисления появятся здесь.", noPayouts: "Вывод средств не входит в WP-6.11B: интерфейс не предлагает действие без утверждённого owner API.",
    },
    articles: {
      eyebrow: "Контент", title: "Статьи", lead: "Состояния и доступные операции всегда приходят от сервера.", create: "Новая статья", loading: "Загружаем статьи", emptyTitle: "Статей пока нет", emptyBody: "Создайте первый черновик материала.", states: {draft: "Черновик", scheduled: "Запланирована", published: "Опубликована"}, updated: "Изменено {{date}}", edit: "Редактировать", open: "Открыть", editorEyebrow: "Редактор", editTitle: "Редактировать статью", newTitle: "Новая статья", editorLead: "Единый Markdown-исходник и безопасный предпросмотр.", loadingEditor: "Загружаем редактор", titleLabel: "Заголовок", summaryLabel: "Аннотация", bodyLabel: "Содержание", saveDraft: "Сохранить", schedule: "Запланировать", publish: "Опубликовать",
      filters: {state: "Состояние", category: "Категория", all: "Все"}, loadMore: "Показать ещё", loadingMore: "Загружаем…", createUnavailable: "Сервер не разрешает создание статьи.", mutationFailed: "Не удалось выполнить операцию. Если данные изменились, перечитайте актуальную версию.", reload: "Перечитать", uploadFailed: "Не удалось загрузить изображение.", slug: "Slug", h1: "H1", metaTitle: "Meta title", metaDescription: "Meta description", image: "Изображение", imageAttached: "Файл изображения прикреплён", imageAlt: "Alt изображения", removeImage: "Убрать изображение", scheduledAt: "Дата публикации", unschedule: "Снять с расписания", delete: "Удалить",
    },
    kyc: {
      eyebrow: "Доверие и выплаты", title: "Верификация эксперта", lead: "Политика, история заявок и доступные действия приходят от сервера.", loading: "Загружаем статус верификации", loadingHistory: "Загружаем историю заявок", statusEyebrow: "Текущий статус", states: {none: "Не начата", submitted: "На проверке", approved: "Одобрена", rejected: "Нужны исправления"}, currentCase: "Заявка № {{number}} · {{date}}", policyVersion: "Политика v{{version}}", policyTitle: "Доступность функций", requiresApproved: "Требует одобренной проверки", approvalOptional: "Проверка не обязательна", gates: {catalog: "Каталог", voice_consultations: "Голосовые консультации", services: "Услуги", payouts: "Выплаты", test_mode: "Тестовый режим"}, allowed: "Доступно", blocked: "Заблокировано",
      newSubmission: "Новая заявка", resubmission: "Повторная заявка", submissionBody: "Состав документов фиксируется только при отправке. До неё удаление меняет только локальный список.", uploadFailed: "Не удалось загрузить документ.", submitFailed: "Не удалось отправить заявку. Перечитайте актуальное состояние.", document: "Документ", upload: "Загрузить", fileMeta: "{{contentType}} · {{size}} байт", removeLocal: "Убрать локально", submit: "Отправить на проверку",
      historyEyebrow: "История", historyTitle: "Неизменяемые заявки", historyLoadFailed: "Не удалось загрузить следующую страницу.", detailLoadFailed: "Не удалось открыть заявку.", documentOpenFailed: "Не удалось открыть документ.", historyEmptyTitle: "История пуста", historyEmptyBody: "Отправленные заявки появятся здесь.", caseTitle: "Заявка № {{number}}", caseMeta: "{{count}} док. · {{date}}", documents: "Документы", loadMore: "Показать ещё", open: "Открыть", positionedDocument: "{{position}}. {{filename}}",
    },
  },
  reviews: {
    mine: {
      eyebrow: "Репутация",
      title: "Мои отзывы",
      lead: "Здесь видны отправленные отзывы, их текущий статус и опубликованные ответы экспертов.",
      loading: "Загружаем отзывы",
      listAria: "История моих отзывов",
      emptyTitle: "Отзывов пока нет",
      emptyBody: "После отправки отзыв появится здесь со статусом модерации.",
    },
    received: {
      eyebrow: "Репутация эксперта",
      title: "Отзывы клиентов",
      lead: "Статусы и возможность единственного ответа определяет сервис Marketplace.",
      loading: "Загружаем отзывы клиентов",
      listAria: "Полученные отзывы клиентов",
      emptyTitle: "Отзывов пока нет",
      emptyBody: "Опубликованные и ожидающие решения отзывы появятся здесь.",
    },
    states: {
      pending_moderation: "На модерации",
      published: "Опубликован",
      hidden: "Скрыт",
    },
    card: {
      expert: "Эксперт · ID {{id}}",
      client: "Клиент · ID {{id}}",
      anonymizedClient: "Автор удалил аккаунт",
      score: "Оценка: {{score}} из 5",
      created: "Отправлен",
      updated: "Обновлён",
      replyAria: "Ответ эксперта",
      replyTitle: "Ответ эксперта",
    },
    submit: {
      title: "Оставить отзыв",
      lead: "Доступность проверит Marketplace при отправке. До ответа сервера форма не обещает право на публикацию.",
      score: "Оценка",
      scoreValue: "{{score}} из 5",
      text: "Текст отзыва",
      textHelp: "От 6 до 1000 символов. Текст отображается без Markdown и HTML.",
      action: "Отправить отзыв",
      submitting: "Отправляем…",
      retry: "Повторить ту же отправку",
      recovered: "Незавершённая отправка восстановлена. Повтор использует тот же ключ операции.",
      successTitle: "Отзыв отправлен на модерацию",
      successBody: "Публикация не обещана: актуальный статус уже запрашивается у сервиса.",
      another: "Оставить ещё один отзыв",
    },
    reply: {
      formAria: "Ответить на отзыв",
      text: "Ответ эксперта",
      help: "Один ответ, от 1 до 1000 символов. После отправки изменить или удалить его нельзя.",
      action: "Опубликовать ответ",
      submitting: "Публикуем…",
      retry: "Повторить ту же отправку",
      recovered: "Незавершённый ответ восстановлен. Повтор использует тот же ключ операции.",
    },
    textCount: "Символов: {{count}} / 1000",
    loadMore: "Показать ещё",
    loadingMore: "Загружаем…",
    errors: {
      validationTitle: "Проверьте отзыв",
      validationBody: "Оценка, текст или параметры запроса не прошли проверку.",
      unauthenticatedTitle: "Нужно войти",
      unauthenticatedBody: "Сессия завершилась. Войдите и откройте раздел снова.",
      ineligibleTitle: "Отзыв сейчас недоступен",
      ineligibleBody: "Marketplace проверил условия и не разрешил отправку. Суммы и пороги не раскрываются.",
      notAllowedTitle: "Действие недоступно",
      notAllowedBody: "Текущий аккаунт не может выполнить это действие.",
      notFoundTitle: "Отзыв не найден",
      notFoundBody: "Ресурс отсутствует или не принадлежит текущему аккаунту.",
      conflictTitle: "Данные уже изменились",
      conflictBody: "Обновите список перед новым действием.",
      replyConflictBody: "Версия отзыва изменилась или ответ уже опубликован. Обновите список.",
      unavailableTitle: "Отзывы временно недоступны",
      readUnavailableBody: "Сервис не ответил. Повторите загрузку списка позже.",
      unavailableBody: "Сервис не подтвердил результат. Повторите ту же операцию — ключ сохранён.",
      pendingTitle: "Есть незавершённая операция",
      pendingBody: "Сначала завершите восстановленную отправку с тем же ключом.",
      internalTitle: "Ответ сервиса не подтверждён",
      internalBody: "Интерфейс не показывает непроверенные данные. Повторите запрос позже.",
    },
  },
  phoneRecovery: {
    title: "Подтвердить новый телефон",
    intro: "После проверки поддержкой и отправки SMS введите номер заявки, полученный через канал поддержки, и код с нового телефона. Эта форма не открывает вход в аккаунт.",
    operationId: "Номер заявки",
    code: "Код из SMS",
    checking: "Проверяем…",
    confirm: "Подтвердить телефон",
    completed: "Телефон подтверждён. Старые сессии завершены; войдите заново с новым номером.",
    signIn: "Перейти ко входу",
    invalid: "Не удалось подтвердить заявку или код. Проверьте данные или обратитесь в поддержку.",
    rateLimited: "Слишком много попыток. Подождите и обратитесь в поддержку, если проблема повторится.",
    captchaRequired: "Подтвердите проверку и повторите ввод кода.",
    unavailable: "Восстановление сейчас недоступно. Обратитесь в поддержку.",
  },
  admin: {
    phoneChange: {
      eyebrow: "Восстановление контакта", title: "Смена телефона через поддержку", openAccountCard: "Открыть карточку аккаунта для смены телефона",
      proofNotice: "Выберите подходящий способ проверки права заявителя на аккаунт. Документы можно запросить по необходимости; после проверки явно подтвердите своё решение. Заявку может подтвердить создавший её оператор.",
      loading: "Загружаем заявку…", newPhone: "Новый номер в формате +…", reason: "Основание", caseRef: "Код внешнего обращения (необязательно)", evidenceRef: "Код доказательства (необязательно)",
      reasons: {old_phone_lost: "Прежний номер утрачен", old_phone_reassigned: "Прежний номер передан другому абоненту"},
      cancelReasons: {proof_invalid: "Доказательство не подтвердилось", user_request: "По просьбе заявителя", replacement_requested: "Нужна новая заявка с иными данными", operation_error: "Операционная ошибка"},
      attestApprove: "Я выбранным способом установил право заявителя на аккаунт.",
      create: "Создать заявку", approve: "Подтвердить решение о проверке",
      sendOtp: "Отправить SMS на новый номер", otpSent: "Код отправлен. Срок действия: {{until}}.",
      operationId: "Номер заявки", expiresAt: "Заявка действует до", candidate: "Новый номер", creator: "Создал оператор", approver: "Подтвердил оператор",
      claimantInstruction: "Передайте номер заявки заявителю через утверждённый внешний канал. Код SMS не запрашивайте и не вводите за него.",
      cancelReason: "Причина отмены", cancel: "Отменить заявку", reload: "Обновить состояние",
      states: {pending_review: "Ожидает решения оператора", approved: "Одобрена", completed: "Телефон изменён", cancelled: "Отменена", expired: "Срок истёк"},
      errors: {forbidden: "Нет доступа к этой заявке.", notFound: "Заявка не найдена или больше не активна.", conflict: "Заявка или аккаунт изменились. Обновите состояние.", validation: "Проверьте поля заявки.", rateLimited: "Слишком много попыток. Повторите позже.", unavailable: "Результат не подтверждён. Обновите состояние или повторите ту же попытку."},
    },
    support: {
      nav: {root: "Поддержка", dialogs: "Обращения", signals: "Сигналы"},
      sectionNavigationAria: "Разделы поддержки", filtersAria: "Фильтры очереди", assignmentFilter: "Назначение", stateFilter: "Состояние",
      filters: {unassigned: "Без оператора", mine: "Мои", all: "Все", open: "Открытые", resolved: "Решённые"},
      created: "Создан", updated: "Обновлён", reason: "Основание", noteOptional: "Заметка (необязательно)", notes: "Заметки оператора", noNotes: "Заметок пока нет", noteBy: "Оператор · ID {{id}}", latestNotes: "Последние заметки из карточки", pagedNotes: "Постраничный список заметок", openNotePages: "Открыть список заметок", olderNotes: "Ранние заметки", addNote: "Добавить заметку",
      resolve: "Решить", reopen: "Открыть снова", reload: "Перечитать", retrySame: "Повторить ту же попытку", loading: "Загружаем…", previous: "Назад", next: "Далее", paginationAria: "Страницы очереди", queueChanged: "Очередь изменилась. Показана первая страница.", requestId: "ID запроса: {{id}}",
      states: {
        labels: {open: "Открыт", resolved: "Решён"},
        loadingTitle: "Загружаем данные", loadingBody: "Получаем актуальное состояние у Chat.",
        emptyTitle: "Очередь пуста", emptyBody: "По выбранным фильтрам записей сейчас нет.",
        route_not_foundTitle: "Раздел не найден", route_not_foundBody: "Проверьте адрес раздела поддержки.",
        unauthenticatedTitle: "Сессия завершена", unauthenticatedBody: "Войдите снова и повторите запрос.",
        forbiddenTitle: "Нет доступа", forbiddenBody: "Роль, назначение или текущий режим не дают доступ к этой записи.",
        not_foundTitle: "Запись не найдена", not_foundBody: "Объект отсутствует или ссылка больше не актуальна.",
        validationTitle: "Проверьте данные", validationBody: "Идентификатор, фильтр или данные решения не прошли проверку.",
        conflictTitle: "Состояние изменилось", conflictBody: "Действие не выполнено. Перечитайте актуальную версию и примите решение заново.",
        unavailableTitle: "Источник временно недоступен", unavailableBody: "Результат не подтверждён. При неопределённой операции повторите ту же попытку.",
        integrityTitle: "Ответ не прошёл проверку", integrityBody: "Интерфейс остановил показ данных, не соответствующих контракту.",
      },
      caseReasons: {answered: "Ответ дан", no_action_needed: "Действий не требуется", further_work: "Требуется продолжение", requester_follow_up: "Новое сообщение пользователя"},
      signalReasons: {contact_detected: "Контакт обнаружен", false_positive: "Ложное срабатывание", no_action_needed: "Действий не требуется", further_review: "Повторная проверка"},
      dialogs: {
        eyebrow: "Обращения", title: "Очередь обращений", lead: "До назначения видны только краткие сведения. История и действия открываются текущему оператору.",
        requester: "Обращение пользователя · ID {{id}}", noPreview: "Предпросмотр недоступен", unread: "Непрочитано", back: "К обращениям", detailEyebrow: "Карточка обращения",
        assignmentTitle: "Доступна краткая карточка", assignmentBody: "Для истории, ответа и решения назначьте обращение себе.", assign: "Назначить себе", takeover: "Переназначить себе", takeoverConfirm: "Переназначить обращение себе? Текущий оператор потеряет доступ к истории и файлам.",
        caseTitle: "Решение по обращению", caseState: "Состояние: {{state}}", assignee: "Назначен оператору · ID {{id}}", historyAria: "История обращения", history: "История сообщений", noMessages: "Сообщений пока нет", authors: {requester: "Пользователь", operator: "Оператор", system: "Система"}, pendingAttachment: "Вложение: доступ ожидается", attachment: "Вложение", openAttachment: "Открыть вложение", systemMessage: "Системное сообщение", latest: "К последним", markRead: "Отметить прочитанным", readConfirm: "Отметить показанные сообщения прочитанными?",
        compose: "Ответ пользователю", message: "Текст сообщения", send: "Отправить", file: "Вложение", attach: "Прикрепить файл",
      },
      signals: {
        eyebrow: "Цензура Chat", title: "Очередь сигналов", lead: "Категории и количества без текста, фрагментов и регулярных выражений.",
        signal: "Сигнал {{id}}", categories: "Телефон: {{phone}} · Email: {{email}} · ссылки: {{link}} · мессенджеры: {{messenger}}", back: "К сигналам", detailEyebrow: "Карточка сигнала",
        assignmentTitle: "Доступны только метаданные", assignmentBody: "Для решения и отдельного просмотра оригинала назначьте сигнал себе.", assign: "Взять сигнал", takeover: "Переназначить сигнал", takeoverConfirm: "Переназначить сигнал себе? Предыдущий оператор потеряет доступ.",
        metadata: "Метаданные сигнала", policyVersion: "Версия политики", decisionTitle: "Решение по сигналу", assignee: "Назначен оператору · ID {{id}}",
        originalTitle: "Оригинал сообщения", originalLead: "Каждый просмотр отдельно фиксируется в аудите. Текст исчезнет при закрытии карточки или обновлении.", reveal: "Показать оригинал", closeOriginal: "Закрыть оригинал",
      },
    },
    backoffice: "Админка",
    yes: "Да",
    no: "Нет",
    users: "Пользователи",
    experts: "Эксперты",
    homeAria: "Главная страница админки",
    navigationAria: "Разделы админки",
    breadcrumbAria: "Хлебные крошки",
    operatorId: "Оператор · ID {{id}}",
    scopeNote: "Доступ определяется ролью оператора и проверяется сервером.",
    notifications: {
      nav: "Уведомления", eyebrow: "Шаблоны и каналы", title: "Шаблоны уведомлений", lead: "Зарегистрированные email и SMS шаблоны. Изменения влияют только на новые отправки.",
      detailTitle: "Шаблон", detailLead: "Проверьте допустимые переменные и сохраните новую версию с основанием.",
      key: "Ключ", channelLabel: "Канал", channel: {email: "Email", sms: "SMS"}, version: "Версия", updated: "Обновлён", open: "Открыть шаблон",
      subject: "Тема", body: "Текст", subjectLocked: "Тема защищена", subjectHelp: "До 200 байт UTF-8, без переменных и переносов строки.", bodyHelp: "{{count}} из {{limit}} байт UTF-8",
      params: "Допустимые переменные", noParams: "без переменных", paramsHelp: "Сохраните каждую указанную переменную без изменения написания. Значения подставляет сервис при доставке.",
      payoutSubjectLock: "Неизменяемая тема выплаты по D-085", smsSubjectLock: "У SMS нет темы", unknownLock: "Редактирование запрещено владельцем шаблона", compareCurrent: "Сравнить с актуальным текстом",
      preview: "Показать пример", previewing: "Проверяем…", previewTitle: "Предпросмотр", syntheticOnly: "Используются только синтетические данные. Письмо или SMS не отправляется.",
      reason: "Основание изменения", reasonBytes: "{{count}} из 500 байт", save: "Сохранить новую версию", retrySame: "Повторить ту же попытку", unsaved: "Есть несохранённые изменения. Сбросьте их перед переходом на другую страницу.", discard: "Сбросить изменения",
      payoutApprovedHint: "Выплата уже проведена. Текст должен сообщать о проведённой выплате и сумме списания.", payoutRejectedHint: "Заявка уже отклонена. Текст должен сообщать об отклонении и причине.",
      channelsTitle: "Состояние каналов", channelsLead: "Управление каналами остаётся в системных настройках.", channelOn: "Включён", channelOff: "Выключен", channelUnknown: "Не удалось подтвердить состояние", channelSkip: "Выключенный канал завершает новую доставку без отправки провайдеру.", openSettings: "Открыть системные настройки", otherSettings: "Там же находятся SMS sandbox и число попыток доставки.",
      requestId: "ID запроса: {{id}}", retry: "Повторить загрузку", notice: {saved: "Шаблон сохранён. Загружаем актуальную версию.", stale: "Данные изменились. Загружаем актуальную версию; проверьте её перед новой попыткой."},
      states: {
        loadingTitle: "Загружаем шаблоны", loadingBody: "Ожидаем приватный ответ владельца данных.", emptyTitle: "Шаблонов нет", emptyBody: "Зарегистрированные шаблоны пока не найдены.",
        unauthenticatedTitle: "Сессия завершена", unauthenticatedBody: "Войдите снова.", forbiddenTitle: "Нет доступа к шаблонам", forbiddenBody: "Раздел доступен администратору и суперадминистратору.",
        not_foundTitle: "Шаблон не найден", not_foundBody: "Этот ключ не зарегистрирован.", staleTitle: "Версия изменилась", staleBody: "Перечитайте текущий текст и примите решение снова.",
        idempotency_conflictTitle: "Ключ попытки уже использован", idempotency_conflictBody: "Проверьте актуальный шаблон и начните новую попытку.", preconditionTitle: "Условия изменились", preconditionBody: "Перечитайте шаблон перед повтором.",
        validationTitle: "Проверьте текст", validationBody: "Поле, переменные или основание не прошли проверку владельца.", unavailableTitle: "Сервис временно недоступен", unavailableBody: "Исход сохранения может быть неопределён. Повторите ту же попытку.",
        integrityTitle: "Ответ не прошёл проверку", integrityBody: "Интерфейс не показывает данные вне приватного контракта.",
      },
      names: {
        email_confirmation: "Подтверждение email", phone_otp: "Код подтверждения телефона", password_reset_email: "Восстановление пароля по email", password_reset_sms: "Восстановление пароля по SMS", account_blocked: "Блокировка аккаунта", account_deleted_email_v1: "Удаление аккаунта по email", account_deleted_sms_v1: "Удаление аккаунта по SMS",
        guest_paid_access: "Доступ к оплаченному гостевому заказу", expert_paid_order: "Оплаченный заказ эксперту", booking_unpaid_client_email: "Неоплаченная бронь клиенту по email", booking_unpaid_client_sms: "Неоплаченная бронь клиенту по SMS", booking_upcoming_client_email: "Скорая консультация клиенту по email", booking_upcoming_client_sms: "Скорая консультация клиенту по SMS", booking_upcoming_expert_email: "Скорая консультация эксперту по email", booking_upcoming_expert_sms: "Скорая консультация эксперту по SMS", booking_expert_unavailable_client_email: "Отмена экспертом по email", booking_expert_unavailable_client_sms: "Отмена экспертом по SMS", payout_approved_email_v1: "Выплата проведена", payout_rejected_email_v1: "Заявка на выплату отклонена", review_published_email_v1: "Публикация отзыва", review_replied_email_v1: "Ответ на отзыв", chat_message: "Новое сообщение чата",
      },
    },
    close: "Закрыть",
    consultations: {
      nav: {root: "Консультации", callEvents: "Журнал звонков", recovery: "Разбор заказа"},
      sectionNavigationAria: "Разделы privileged-разбора консультаций",
      redirecting: "Открываем журнал звонков",
      explicitAuditRead: "Каждая загрузка аудируется владельцем данных и выполняется только по этому явному действию.",
      seconds: "сек.",
      minorUnits: "минимальные единицы",
      bytes: "После нормализации: {{count}} из 2000 байт",
      retrySame: "Повторить ту же попытку",
      freshPreview: "Получить новый preview",
      mode: {session_attention: "Неопределённый исход звонка", no_show_attention: "Не доказано отсутствие клиента"},
      eventKind: {ringing_expert: "Вызов эксперта", ringing_client: "Вызов клиента", connected: "Соединение", finished: "Завершение", failed: "Сбой"},
      callState: {created: "Создан", ringing_expert: "Вызов эксперта", ringing_client: "Вызов клиента", connected: "Соединён", finished: "Завершён", failed: "Сбой"},
      initiator: {client: "Клиент", expert: "Эксперт", system: "Система"},
      outcome: {applied: "Применено", no_effect: "Без эффекта", deferred: "Отложено", rejected: "Отклонено", retryable: "Требует повтора"},
      processingReason: {
        application_pending: "Применение ещё не завершено", applied: "Применено владельцем", redundant: "Избыточное событие", stale: "Устаревшее событие",
        missing_predecessor: "Нет предшествующего события", identity_mismatch: "Не совпала идентичность", terminal_conflict: "Конфликт terminal-состояния",
        owner_unavailable: "Владелец недоступен", storage_unavailable: "Хранилище недоступно", force_finished: "Заказ закрыт ForceFinish",
      },
      forceReason: {provider_outcome_unresolved: "Исход провайдера не разрешён", client_absence_unproven: "Отсутствие клиента не доказано"},
      blockReason: {
        none: "Можно исполнить", feature_disabled: "Owner control выключен", order_not_eligible: "Заказ не подходит", target_not_attention: "Target не требует вмешательства",
        call_event_pending: "Сначала обработайте событие", prerequisite_pending: "Предварительный процесс не завершён", integrity_conflict: "Нарушена целостность источника",
      },
      states: {
        idle_journalTitle: "Журнал ещё не запрошен", idle_journalBody: "Нажмите «Загрузить журнал». Автоматической загрузки и фонового обновления нет.",
        idle_recoveryTitle: "Укажите точный Order ID", idle_recoveryBody: "Call log загружается только по явному запросу. Общего поиска заказов и автоматического выбора session нет.",
        loadingTitle: "Получаем подтверждённые данные", loadingBody: "Ожидаем приватный ответ владельца данных.",
        emptyTitle: "Строк нет", emptyBody: "Владелец вернул пустую страницу. Это не запускает новый запрос автоматически.",
        route_not_foundTitle: "Страница консультаций не найдена", route_not_foundBody: "Проверьте адрес или откройте журнал звонков.",
        unauthenticatedTitle: "Сессия завершена", unauthenticatedBody: "Войдите снова перед privileged-разбором.",
        forbiddenTitle: "Нет доступа к консультациям", forbiddenBody: "Раздел доступен только администратору и суперадминистратору. Сервер проверяет каждый запрос повторно.",
        not_foundTitle: "Target не найден", not_foundBody: "Точный Order, session, process или event отсутствует.",
        validationTitle: "Проверьте точные данные", validationBody: "Идентификатор, target или основание не прошло проверку.",
        staleTitle: "Версия заказа изменилась", staleBody: "Нужен новый audited preview. Команда не повторяется автоматически.",
        preconditionTitle: "Условия уже изменились", preconditionBody: "Перечитайте call log и получите новый preview.",
        idempotency_conflictTitle: "Ключ использован с другими данными", idempotency_conflictBody: "Текущая попытка остановлена. Начните новый flow с новым preview.",
        recovery_disabledTitle: "Recovery control выключен", recovery_disabledBody: "BFF пока не пропускает recovery-команды. Privileged чтение остаётся доступным.",
        dependency_unavailableTitle: "Consultations временно недоступен", dependency_unavailableBody: "Результат mutation может быть неопределён. Повторите только ту же сохранённую в памяти попытку.",
        integrityTitle: "Ответ не прошёл проверку", integrityBody: "Интерфейс не показывает данные, не соответствующие опубликованному private contract.",
      },
      errors: {
        unauthenticatedTitle: "Сессия завершена", unauthenticatedBody: "Войдите снова перед выполнением действия.",
        forbiddenTitle: "Действие недоступно", forbiddenBody: "Effective role не разрешает эту операцию.",
        not_foundTitle: "Target не найден", not_foundBody: "Точный объект отсутствует или уже недоступен.",
        validationTitle: "Проверьте данные", validationBody: "Идентификатор, основание, note или версия не прошли проверку.",
        staleTitle: "Preview устарел", staleBody: "Команда не выполнена. Получите новый preview и примите решение заново.",
        preconditionTitle: "Условия изменились", preconditionBody: "Команда не выполнена. Перечитайте call log и получите новый preview.",
        idempotency_conflictTitle: "Попытка конфликтует", idempotency_conflictBody: "Тот же ключ уже связан с другими данными. Нужен новый preview и новая попытка.",
        recovery_disabledTitle: "Recovery control выключен", recovery_disabledBody: "Команда не отправлена владельцу. Дождитесь операционной активации.",
        dependency_unavailableTitle: "Результат не подтверждён", dependency_unavailableBody: "Повтор использует тот же ключ и неизменные данные только из памяти формы.",
        integrityTitle: "Результат не подтверждён", integrityBody: "Ответ нарушил безопасный контракт. Повтор использует ту же незавершённую попытку.",
      },
      journal: {
        eyebrow: "Audited CallEvent journal", title: "Журнал событий звонков", lead: "Только нормализованные owner-факты и последний processing attempt. Raw callback, endpoint, adapter identity и внутренние ошибки не выдаются.",
        limit: "Строк на странице", load: "Загрузить журнал", refresh: "Явно перечитать", tableAria: "Приватный журнал событий звонков", paginationAria: "Навигация по страницам журнала звонков",
        event: "CallEvent", order: "OrderRef", session: "Session", kind: "Событие", received: "Получено", providerFacts: "Нормализованные provider facts", processing: "Обработка", action: "Действие",
        notProcessed: "Попыток нет", reprocess: "Повторить обработку",
      },
      reprocess: {
        eyebrow: "Immutable event", title: "Повторить обработку события?", body: "Payload события не меняется. Укажите только обязательное основание и явно подтвердите повтор.", reason: "Основание", confirm: "Подтвердить reprocess",
        resultEyebrow: "Owner result", resultTitle: "Повтор обработки завершён", attempt: "Попытка", version: "Версия stream", replayed: "Владелец вернул durable replay ранее завершённой команды.", performed: "Создан новый owner processing attempt. Журнал перечитывается только явной кнопкой.",
      },
      recovery: {
        eyebrow: "Exact-ID recovery", title: "Разбор проблемного заказа", lead: "Browser не вычисляет eligibility, тариф или деньги. Он передаёт точный target и показывает только server preview.",
        orderId: "Consultation Order ID", loadLog: "Загрузить call log", loadingLog: "Загружаем…", targetEyebrow: "Audited ForceFinish", targetTitle: "Точный recovery target", targetLead: "Выберите target вручную. UI не выбирает последнюю или активную session автоматически.",
        mode: "Режим", sessionId: "CallSession ID", seconds: "Effective duration, целые секунды", processId: "No-show process ID", reason: "Фиксированная причина", noDuration: "В no-show режиме duration отсутствует целиком и не отправляется в запросе.", preview: "Получить server preview", previewing: "Проверяем…",
      },
      callLog: {eyebrow: "Audited call log", title: "Сессии заказа", empty: "Владелец не вернул ни одной session.", choose: "Выбрать вручную", initiator: "Инициатор", maximum: "Maximum", started: "Начало", billedMinutes: "Billed minutes", billableSeconds: "Billable seconds", billedAmount: "Billed amount"},
      preview: {eyebrow: "Server preview", executable: "Команду можно подтвердить", blocked: "Команда сейчас заблокирована", evaluated: "Проверено", version: "Source version", execute: "Открыть подтверждение"},
      impact: {mode: "Ветка", used: "Used amount", refundable: "Refundable amount", terminal: "Terminal outcome", technicalFailure: "Отмена · технический сбой", effective: "Effective duration", maximum: "Correction maximum", billedMinutes: "Billed minutes", billedAmount: "Billed amount"},
      execute: {eyebrow: "Необратимое owner-действие", title: "Подтвердить ForceFinish?", body: "Команда повторит неизменный target и source version из показанного preview.", privacyTitle: "Не добавляйте чувствительные данные", privacyBody: "Запрещены контакты, credentials, provider payload/signature и secrets. Note хранится только в audit.", note: "Обязательная operator note", confirm: "Выполнить ForceFinish"},
      result: {eyebrow: "Owner-confirmed result", title: "ForceFinish выполнен", forceId: "ForceFinish ID", version: "Resulting version", terminalEvent: "Terminal event", callFinishedEvent: "CallFinished event", finished: "Завершено", explicitRefresh: "Явно перечитать call log"},
    },
    moderation: {
      nav: {root: "Модерация", reviews: "Отзывы", comments: "Комментарии"},
      sectionNavigationAria: "Разделы модерации",
      redirecting: "Открываем доступный раздел модерации",
      review: "Отзыв",
      comment: "Комментарий",
      content: "Содержание",
      accounts: "Участники",
      state: "Состояние",
      action: "Действие",
      article: "Статья",
      created: "Создан",
      updated: "Обновлён",
      client: "Клиент · ID {{id}}",
      expert: "Эксперт · ID {{id}}",
      clientLabel: "Клиент",
      expertLabel: "Эксперт",
      articleWithId: "Статья {{id}}",
      score: "Оценка: {{score}} из 5",
      scoreLabel: "Оценка",
      textLabel: "Текст отзыва",
      textCount: "Символов: {{count}} / 1000",
      reasonLabel: "Основание",
      reasonCount: "Символов: {{count}} / 2000",
      loadMore: "Показать ещё",
      loadingMore: "Загружаем…",
      paginationAria: "Навигация по страницам комментариев",
      paginationFailed: "Не удалось загрузить продолжение очереди. Повторите попытку.",
      reload: "Перечитать актуальное состояние",
      retrySameAttempt: "Повторить ту же попытку",
      refreshFocusLabel: "Результат обновления модерации",
      refreshLoading: "Перечитываем актуальное состояние",
      refreshReady: "Актуальное состояние загружено",
      impersonationReadOnly: "В режиме входа под пользователем решения модерации недоступны. Выйдите из режима, чтобы выполнить действие.",
      actions: {publish: "Опубликовать", hide: "Скрыть", edit: "Исправить"},
      reasons: {
        CONTENT_APPROVED: "Материал проверен",
        CONTENT_POLICY: "Нарушение правил содержания",
        PERSONAL_DATA: "Персональные данные",
        PROHIBITED_CONTACT: "Запрещённые контакты",
        TYPOGRAPHY: "Типографическое исправление",
        SCORE_CORRECTION: "Исправление оценки",
        CONTENT_AND_SCORE_CORRECTION: "Исправление текста и оценки",
      },
      states: {
        labels: {pending_moderation: "Ожидает решения", published: "Опубликован", hidden: "Скрыт"},
        loadingTitle: "Загружаем модерацию", loadingBody: "Получаем актуальное состояние у сервиса-владельца.",
        empty_reviewsTitle: "Очередь пуста", empty_reviewsBody: "Отзывов, ожидающих решения, сейчас нет.",
        empty_commentsTitle: "Комментарии не найдены", empty_commentsBody: "Для выбранных фильтров нет опубликованных или скрытых комментариев.",
        end_commentsTitle: "Продолжение списка закончено", end_commentsBody: "По этому курсору больше нет комментариев. Вернитесь на предыдущую страницу.",
        forbiddenTitle: "Нет доступа к разделу", forbiddenBody: "Текущая роль не может просматривать этот объект модерации. Сервер повторно проверяет каждый запрос.",
        route_not_foundTitle: "Страница модерации не найдена", route_not_foundBody: "Проверьте адрес или откройте доступный раздел из навигации.",
        unauthenticatedTitle: "Сессия завершена", unauthenticatedBody: "Войдите снова и повторите запрос.",
        not_foundTitle: "Запись не найдена", not_foundBody: "Объект отсутствует или ссылка больше не актуальна.",
        validationTitle: "Проверьте параметры", validationBody: "Адрес, фильтр или данные решения не прошли проверку.",
        conflictTitle: "Запись уже изменилась", conflictBody: "Интерфейс перечитает актуальную версию. Примите новое решение после загрузки.",
        unavailableTitle: "Источник временно недоступен", unavailableBody: "Сервис-владелец не подтвердил актуальное состояние. Повторите запрос позже.",
        integrityTitle: "Ответ не прошёл проверку", integrityBody: "Интерфейс остановил показ данных, не соответствующих опубликованному контракту.",
      },
      errors: {
        unauthenticatedTitle: "Сессия завершена", unauthenticatedBody: "Войдите снова перед выполнением действия.",
        forbiddenTitle: "Действие недоступно", forbiddenBody: "Текущая роль или режим входа не разрешает это решение.",
        not_foundTitle: "Запись не найдена", not_foundBody: "Объект отсутствует или больше недоступен.",
        validationTitle: "Проверьте решение", validationBody: "Основание, текст, оценка или версия не прошли проверку.",
        conflictTitle: "Версия уже изменилась", conflictBody: "Черновик закрыт. Перечитайте запись и примите решение заново.",
        unavailableTitle: "Результат не подтверждён", unavailableBody: "Повторите ту же попытку: ключ и точные данные сохранены только в памяти этой формы.",
        integrityTitle: "Результат не подтверждён", integrityBody: "Ответ не соответствует безопасному контракту. Повтор использует тот же ключ попытки.",
      },
      reviews: {
        eyebrow: "Репутация", title: "Отзывы ожидают решения", lead: "FIFO-очередь Marketplace содержит только отзывы в состоянии ожидания модерации.",
        shown: "В очереди: {{count}}", fifo: "Сначала самые ранние", tableAria: "Очередь отзывов на модерацию", back: "К очереди отзывов",
        detailEyebrow: "Карточка отзыва", anonymized: "Автор анонимизирован", anonymizedReadOnly: "Отзыв заблокирован после анонимизации автора и доступен только для чтения.",
        replyAria: "Неизменяемый ответ эксперта", reply: "Ответ эксперта", firstPublished: "Первая публикация", metadata: "Метаданные", decisionEyebrow: "Решение модератора", decisionTitle: "Доступные действия",
        dialog: {
          publishTitle: "Опубликовать отзыв?", publishBody: "Marketplace повторно проверит состояние и атомарно обновит публичную репутацию. Доставка письма эксперту выполняется отдельно.",
          hideTitle: "Скрыть отзыв?", hideBody: "Отзыв перестанет участвовать в публичной репутации после подтверждения владельцем данных.",
          editTitle: "Исправить отзыв", editBody: "Измените оценку и/или текст. Рейтинг и lifecycle остаются ответственностью Marketplace.",
        },
      },
      comments: {
        eyebrow: "Контент", title: "Комментарии к статьям", lead: "Анонимные комментарии можно фильтровать и только скрывать. Публикация, редактирование, удаление и восстановление недоступны.",
        filtersAria: "Фильтры комментариев", articleFilter: "Article ID", stateFilter: "Состояние", allStates: "Все состояния", applyFilters: "Применить",
        shown: "Показано: {{count}}", anonymous: "Комментарии анонимны", tableAria: "Комментарии на постмодерации", noAction: "Только чтение",
        hideEyebrow: "Постмодерация", hideTitle: "Скрыть комментарий?", hideBody: "Комментарий #{{id}} сразу исчезнет из актуального публичного списка. Закэшированная страница может обновиться позже.",
      },
    },
    directoryEyebrow: "Каталог аккаунтов",
    usersTitle: "Пользователи",
    usersLead: "Поиск и просмотр учётных записей платформы.",
    expertsTitle: "Эксперты",
    expertsLead: "Аккаунты с ролью эксперта из общего каталога пользователей.",
    fixtureScenario: "Сценарий ревью",
    scenarios: {normal: "Обычная выдача", empty: "Пустая выдача", error: "Ошибка сервиса", forbidden: "Нет доступа", conflict: "Конфликт"},
    filtersAria: "Фильтры каталога",
    searchLabel: "Поиск",
    searchPlaceholder: "ID, точный email или телефон, начало имени",
    search: "Найти",
    roleFilter: "Роль",
    allRoles: "Все роли",
    stateFilter: "Состояние",
    allStates: "Все состояния",
    sortLabel: "Сортировка",
    sorts: {created_desc: "Сначала новые", updated_desc: "Недавно изменённые", name_asc: "По имени"},
    roles: {
      user: "Пользователь", expert: "Эксперт", admin: "Администратор", support: "Поддержка",
      content_manager: "Контент-менеджер", finance_manager: "Финансы", super_admin: "Суперадминистратор",
    },
    states: {registered: "Зарегистрирован", active: "Активен", blocked: "Заблокирован", anonymized: "Анонимизирован"},
    loadingList: "Загружаем пользователей",
    loadingDetail: "Загружаем карточку пользователя",
    forbiddenTitle: "Нет доступа к каталогу",
    forbiddenBody: "У вашей роли нет права просматривать эти данные. Если доступ нужен для работы, обратитесь к администратору.",
    notFoundTitle: "Аккаунт не найден",
    notFoundBody: "Возможно, аккаунт удалён или ссылка устарела.",
    validationTitle: "Проверьте параметры запроса",
    validationBody: "Один из фильтров или адрес страницы имеет недопустимое значение.",
    conflictTitle: "Данные уже изменились",
    conflictBody: "Обновите карточку и повторите действие с актуальными данными.",
    loadErrorTitle: "Не удалось загрузить данные",
    loadErrorBody: "Сервис временно недоступен. Повторите запрос через несколько секунд.",
    emptyTitle: "Ничего не найдено",
    emptyBody: "Попробуйте изменить запрос или сбросить фильтры.",
    resetFilters: "Сбросить фильтры",
    backToUsers: "К списку пользователей",
    resultsShown_one: "Показан {{count}} аккаунт",
    resultsShown_few: "Показано {{count}} аккаунта",
    resultsShown_many: "Показано {{count}} аккаунтов",
    resultsShown_other: "Показано {{count}} аккаунта",
    privateDataNote: "Контакты скрыты до явного копирования",
    account: "Аккаунт",
    contacts: "Контакты",
    rolesLabel: "Роли",
    stateLabel: "Состояние",
    createdLabel: "Создан",
    updatedLabel: "Обновлён",
    updatedShort: "Изменён {{date}}",
    createdCompact: "Создан {{date}}",
    verified: "Подтверждён",
    notVerified: "Не подтверждён",
    notSpecified: "Не указан",
    copy: "Копировать",
    copied: "Скопировано",
    copyContact: "Копировать {{kind}} полностью",
    contactKinds: {email: "email", phone: "телефон"},
    paginationAria: "Навигация по страницам каталога",
    previousPage: "Назад",
    nextPage: "Следующая",
    accountCardEyebrow: "Аккаунт · ID {{id}}",
    accountId: "Аккаунт {{id}}",
    profileEyebrow: "Основные данные",
    profileTitle: "Профиль пользователя",
    firstName: "Имя",
    lastName: "Фамилия",
    birthDate: "Дата рождения",
    accountState: "Состояние аккаунта",
    email: "Email",
    phone: "Телефон",
    blockReason: "Причина блокировки",
    actionsAria: "Действия с аккаунтом",
    accessEyebrow: "Доступ",
    rolesTitle: "Роли аккаунта",
    roleActionLabel: "Выберите роль",
    grantRole: "Выдать роль",
    revokeRole: "Отозвать",
    rolesReadOnly: "Вам доступен просмотр ролей без изменения.",
    fixtureActionsDisabled: "В режиме визуального ревью действия не отправляются на сервер.",
    accountActionsEyebrow: "Управление",
    accountActionsTitle: "Действия с аккаунтом",
    accountActionsUnavailable: "Для этого аккаунта действия недоступны вашей роли.",
    block: "Заблокировать аккаунт",
    unblock: "Разблокировать аккаунт",
    impersonate: "Войти от имени пользователя",
    actionErrorTitle: "Действие не выполнено",
    actionErrorBody: "Повторите попытку или передайте номер обращения в поддержку.",
    confirmEyebrow: "Требуется подтверждение",
    blockConfirmTitle: "Заблокировать аккаунт?",
    blockConfirmBody: "{{name}}, ID {{id}}, потеряет доступ к платформе. Причина сохранится в истории административных действий.",
    blockReasonLabel: "Причина блокировки",
    blockReasonPlaceholder: "Кратко опишите основание",
    cancel: "Отмена",
    confirmBlock: "Заблокировать",
    impersonationConfirmTitle: "Войти от имени пользователя?",
    impersonationConfirmBody: "Вы перейдёте в аккаунт {{name}}, ID {{id}}. Все действия останутся связаны с исходным оператором.",
    confirmImpersonation: "Продолжить",
    saving: "Сохраняем…",
    closeDialog: "Закрыть окно",
    routeErrorTitle: "Экран не удалось отобразить",
    routeErrorBody: "Перезагрузите страницу. Если ошибка повторится, передайте номер обращения в поддержку.",
    errorEyebrow: "Ошибка интерфейса",
    routeNotFoundTitle: "Такой страницы нет",
    routeNotFoundBody: "Проверьте адрес или вернитесь в каталог пользователей.",
    openUsers: "Открыть пользователей",
    backToCabinet: "Вернуться в кабинет",
	journals: {
		nav: {root: "Журналы", audit: "Аудит", webhooks: "Webhook", searches: "Поиск", errors: "Технические ошибки"},
		sectionNavigationAria: "Разделы журналов",
		filtersAria: "Фильтры журнала",
		paginationAria: "Навигация по страницам журнала",
		privateNote: "Приватная выдача без сохранения фильтров",
		applyFilters: "Применить фильтры",
		all: "Все",
		missing: "Нет данных",
		open: "Открыть журналы",
		redirecting: "Открываем доступный журнал",
		filters: {from: "С даты и времени", to: "До даты и времени", limit: "Строк на странице"},
		states: {
			loadingTitle: "Загружаем журнал", loadingBody: "Получаем подтверждённую страницу у владельца данных.",
			emptyTitle: "Записей не найдено", emptyBody: "В журнале нет строк с выбранными фильтрами.",
			unauthenticatedTitle: "Сессия завершена", unauthenticatedBody: "Войдите снова, прежде чем открывать журнал.",
			forbiddenTitle: "Нет доступа к журналу", forbiddenBody: "Этот журнал недоступен вашей роли. Сервер дополнительно проверяет право на каждый запрос.",
			validationTitle: "Проверьте фильтры", validationBody: "Параметры запроса не прошли проверку владельца данных.",
			rate_limitedTitle: "Слишком много запросов", rate_limitedBody: "Подождите несколько секунд и повторите запрос с теми же фильтрами.",
			unavailableTitle: "Журнал временно недоступен", unavailableBody: "Источник данных не ответил. Другие журналы продолжают работать независимо.",
			integrityTitle: "Целостность ответа не подтверждена", integrityBody: "Интерфейс остановил показ записи, которая не соответствует безопасному контракту.",
			internalTitle: "Не удалось загрузить журнал", internalBody: "Повторите запрос или передайте номер обращения в поддержку.",
			not_foundTitle: "Запись не найдена", not_foundBody: "Запись отсутствует или больше недоступна.",
			conflictTitle: "Состояние уже изменилось", conflictBody: "Перечитайте актуальные данные и повторите действие.",
			export_limitTitle: "Экспорт слишком большой", export_limitBody: "Сузьте период или фильтры и сформируйте полный файл заново.",
		},
		export: {
			action: "Скачать CSV",
			loading: "Готовим CSV…",
			errors: {
				unauthenticated: "Сессия завершена. Войдите снова.", forbidden: "Нет доступа к экспорту.", not_found: "Данные для экспорта не найдены.",
				validation: "Проверьте фильтры экспорта.", conflict: "Данные изменились. Повторите экспорт.", export_limit: "Файл превышает лимит. Сузьте фильтры.",
				rate_limited: "Слишком много запросов. Повторите позже.", unavailable: "Экспорт временно недоступен.", integrity: "Файл не прошёл проверку целостности.", internal: "Не удалось сформировать CSV.",
			},
		},
		searches: {
			eyebrow: "Поисковые запросы", title: "Журнал поиска", lead: "Успешные страницы публичного каталога с точными фильтрами и числом результатов.",
			filters: {account: "Account ID", query: "Фрагмент запроса", limitHelp: "От 1 до 200 строк; продолжение выдаёт только серверный cursor."},
			validation: {account: "Account ID должен быть положительным целым числом.", query: "Запрос должен быть не длиннее 200 символов и 800 байт.", period: "Начало периода должно быть раньше конца.", limit: "Укажите от 1 до 200 строк."},
			shown_one: "Показана {{count}} запись", shown_few: "Показано {{count}} записи", shown_many: "Показано {{count}} записей", shown_other: "Показано {{count}} записи",
			caption: "Записи поисковых запросов каталога", guest: "Гость", filtersOnly: "Только фильтры", noStructuredFilters: "Без структурированных фильтров",
			account: "Аккаунт {{id}}", resultCount: "Результатов: {{count}}",
			columns: {occurred: "Время", account: "Автор", query: "Запрос", filters: "Фильтры", sort: "Сортировка", results: "Результаты"},
			sort: {relevance: "По релевантности", rating_desc: "По рейтингу", price_asc: "Сначала дешевле", price_desc: "Сначала дороже", availability: "По доступности"},
			presence: {online: "онлайн", busy: "занят", offline: "не в сети"},
			filterValues: {specializations: "Специализации: {{value}}", rating: "Рейтинг от {{value}}", price: "Цена: {{min}}…{{max}} {{currency}}", presence: "Статус: {{value}}", languages: "Языки: {{value}}", countries: "Страны: {{value}}"},
		},
		audit: {
			eyebrow: "Административные события", title: "Аудит действий", lead: "Типизированная история действий без сырых payload и секретов.", financeLead: "Финансовые события Billing и Payments с проверкой источника каждой строки.",
			filters: {producer: "Источник", actorKind: "Тип автора", actorAccount: "Account ID автора", effectiveAccount: "Effective account ID", action: "Действие", subjectType: "Тип объекта", subjectId: "ID объекта", requestId: "Request ID"},
			validation: {period: "Выберите период до 90 дней с началом раньше конца.", limit: "Укажите от 1 до 100 строк.", producer: "Финансовой роли доступны только Billing и Payments.", actor: "Выберите тип автора из опубликованного списка.", account: "Account ID должен быть положительным целым числом и требует автора account.", text: "Один из текстовых фильтров слишком длинный."},
			actorKind: {account: "Аккаунт", system: "Система", anonymous: "Анонимный", provider: "Провайдер"},
			shown_one: "Показана {{count}} запись", shown_few: "Показано {{count}} записи", shown_many: "Показано {{count}} записей", shown_other: "Показано {{count}} записи",
			caption: "Типизированные записи аудита", columns: {time: "Время", event: "Событие", actor: "Автор", subject: "Объект", context: "Контекст", action: "Действие"},
			impersonation: "Имперсонация", reasonPresent: "Основание указано", openDetail: "Открыть", accountActor: "Аккаунт {{id}}", effective: "от имени {{id}}",
			detail: {eyebrow: "Запись аудита", title: "Детали события", record: "Record ID", time: "Время", event: "Событие", actor: "Автор", subject: "Объект", reason: "Основание", request: "Request ID", impersonation: "Impersonation ID", before: "До", after: "После", context: "Контекст", noFields: "Типизированных полей нет.", path: "Поле", kind: "Тип", value: "Значение"},
			valueKind: {string: "Строка", int: "Целое", uint: "Беззнаковое целое", bool: "Логическое", decimal: "Десятичное", timestamp: "Время", duration: "Длительность", string_list: "Список строк"},
			values: {emptyString: "Пустая строка", emptyList: "Пустой список", seconds: "{{value}} с"},
		},
		webhooks: {
			eyebrow: "Приём платежей", title: "Webhook-журнал", lead: "Безопасные метаданные приёма и обработки без тела webhook, заголовков и секретов.",
			filters: {provider: "Provider ref", operation: "Provider operation ID", outcome: "Исход", reason: "Причина", operator: "Нужен оператор"},
			validation: {period: "Начало периода должно быть раньше конца.", limit: "Укажите от 1 до 100 строк.", pair: "Provider ref и operation ID задаются только вместе.", closed: "Выберите значение из опубликованного справочника."},
			shown_one: "Показана {{count}} запись", shown_few: "Показано {{count}} записи", shown_many: "Показано {{count}} записей", shown_other: "Показано {{count}} записи",
			caption: "Безопасные записи платежных webhook", columns: {time: "Получен", provider: "Провайдер", state: "Очередь", outcome: "Последний исход", candidates: "Кандидаты", action: "Действие"},
			queue: {pending: "Ожидает", leased: "Обрабатывается", retry_wait: "Ждёт повтора", closed: "Закрыт", operator_required: "Нужен оператор"},
			stage: {decode: "Разбор", source_ip: "Проверка IP", candidate_lookup: "Поиск кандидата", provider_read: "Чтение провайдера", verification: "Проверка", application: "Применение"},
			outcome: {applied: "Применён", replayed: "Повтор без эффекта", no_effect: "Без эффекта", deferred: "Отложен", retryable: "Можно повторить", rejected: "Отклонён"},
			ip: {not_checked: "Не проверялся", off: "Проверка выключена", allowed: "Разрешён", mismatch_observed: "Несовпадение отмечено", mismatch_rejected: "Несовпадение отклонено"},
			reason: {
				succeeded: "Успешно", canceled: "Отменено", terminal_already_applied: "Терминальный исход уже применён", record_already_applied: "Запись уже применена", provider_pending: "Провайдер ещё обрабатывает", waiting_for_capture_anomaly: "Ожидание capture", binding_missing: "Нет привязки", candidate_not_found: "Кандидат не найден", candidate_not_pending: "Кандидат уже не ожидает", binding_race: "Гонка привязки", provider_unavailable: "Провайдер недоступен", provider_auth: "Ошибка авторизации провайдера", provider_rate_limited: "Лимит провайдера", provider_timeout: "Таймаут провайдера", provider_transport: "Транспорт провайдера", provider_5xx: "Ошибка провайдера", provider_not_found: "Операция у провайдера не найдена", provider_response_invalid: "Некорректный ответ провайдера", provider_status_unknown: "Неизвестный статус провайдера", optimistic_conflict: "Конфликт версии", lease_expired: "Аренда истекла", content_type: "Некорректный Content-Type", json_malformed: "Некорректный JSON", notification_type: "Неизвестный тип уведомления", notification_event: "Неизвестное событие уведомления", operation_id: "Некорректный ID операции", metadata_invalid: "Некорректные метаданные", source_ip: "Недопустимый IP", binding_conflict: "Конфликт привязки", candidate_conflict: "Конфликт кандидата", authoritative_metadata_mismatch: "Метаданные не совпали", operation_identity_mismatch: "Идентификатор операции не совпал", merchant_mismatch: "Merchant не совпал", mode_mismatch: "Режим не совпал", amount_mismatch: "Сумма не совпала", currency_mismatch: "Валюта не совпала", terminal_contradiction: "Противоречивый терминальный статус", integrity: "Ошибка целостности", retry_budget_exhausted: "Лимит повторов исчерпан",
			},
			cycle: "Цикл {{value}}", operatorRequired: "Нужен оператор", intent: "PaymentIntent {{id}}", attempt: "Attempt {{id}}", openDetail: "Открыть",
			detail: {eyebrow: "Webhook-запись", title: "Детали обработки", record: "Record ID", received: "Получен", provider: "Провайдер", body: "Безопасный отпечаток тела", ip: "Решение по IP", queue: "Очередь", attempts: "Попытки обработки", attemptNumber: "Цикл {{cycle}}, попытка {{ordinal}}", noAttempts: "Попыток обработки пока нет."},
			reprocess: {
				title: "Повторная обработка", lead: "Укажите основание. Повтор той же отправки использует тот же ключ идемпотентности.", reason: "Основание", action: "Запустить повтор", reload: "Перечитать запись",
				result: {scheduled: "Повтор поставлен в очередь", already_processing: "Повтор уже выполняется"}, receipt: "Запрос {{id}}, цикл {{cycle}}, {{date}}",
				errors: {unauthenticated: "Сессия завершена.", forbidden: "Действие недоступно роли.", not_found: "Запись не найдена.", validation: "Проверьте основание и актуальную запись.", conflict: "Запись уже изменилась.", export_limit: "Действие превышает лимит.", rate_limited: "Слишком много запросов.", unavailable: "Источник временно недоступен.", integrity: "Ответ не прошёл проверку.", internal: "Повтор не выполнен."},
			},
		},
		errors: {
			eyebrow: "Наблюдаемость", title: "Технические ошибки", lead: "Ограниченная выборка нормализованных ERROR-событий без текста логов и stack trace.", safeOnly: "Только безопасные метаданные", caption: "Нормализованные технические ошибки",
			filters: {service: "Сервис", severity: "Уровень", category: "Категория", request: "Request ID", trace: "Trace ID"},
			validation: {period: "Выберите период до 24 часов с началом раньше конца.", service: "Выберите сервис из списка.", limit: "Укажите от 1 до 200 строк.", category: "Категория должна соответствовать безопасному формату.", request: "Request ID должен соответствовать безопасному формату.", trace: "Trace ID — 32 строчные шестнадцатеричные цифры."},
			service: {bff: "BFF", identity: "Identity", marketplace: "Marketplace", consultations: "Consultations", billing: "Billing", payments: "Payments", chat: "Chat", qna: "Q&A", services: "Services", content: "Content", "platform-support": "Platform Support"},
			shown_one: "Показана {{count}} ошибка", shown_few: "Показано {{count}} ошибки", shown_many: "Показано {{count}} ошибок", shown_other: "Показано {{count}} ошибки",
			columns: {time: "Время", service: "Сервис", category: "Категория", request: "Request ID", trace: "Trace ID", fingerprint: "Fingerprint"}, copyAria: "Копировать {{value}}", truncatedTitle: "Показана ограниченная выборка", truncatedBody: "Источник сообщил о сокращённом результате. Сузьте период или фильтры; пагинация и экспорт недоступны.",
		},
	},
	adapters: {
		nav: {root: "Адаптеры", payments: "Платежи", telephony: "Телефония"},
		sectionNavigationAria: "Разделы управления адаптерами",
		open: "Открыть адаптеры",
		redirecting: "Открываем платёжные адаптеры",
		reload: "Перечитать данные",
		retrySameAttempt: "Повторить ту же попытку",
		installed: "Установлен",
		notInstalled: "Не установлен",
		enabled: "Включён",
		disabled: "Выключен",
		configured: "Настроен",
		notConfigured: "Не настроен",
		active: "Выбран",
		inactive: "Не выбран",
		runtimeAvailable: "Доступен для новых операций",
		runtimeUnavailable: "Недоступен для новых операций",
		allowed: "Разрешено политикой",
		bound: "Привязан",
		notBound: "Не привязан",
		policyVersion: "Версия политики",
		policyUpdated: "Политика обновлена",
		mode: {development: "Разработка", sandbox: "Песочница", production: "Production"},
		scenario: {top_up_wallet: "Пополнение кошелька", cover_order: "Оплата заказа"},
		callback: {none: "Без callback", signed: "Подписанный callback", authoritative_read: "Проверка чтением"},
		coverage: {none: "Покрытие подтверждено", no_configured_adapter: "Нет настроенного адаптера", no_runtime_available_adapter: "Нет runtime-доступного адаптера"},
		availability: {
			ready: "Готов по данным владельца", not_installed: "Не установлен", not_configured: "Не настроен", mode_incompatible: "Режим несовместим",
			health_unknown: "Состояние неизвестно", health_unhealthy: "Проверка неуспешна", health_stale: "Проверка устарела", health_configuration_mismatch: "Проверена другая конфигурация",
		},
		health: {
			label: "Состояние провайдера", reason: "Причина состояния", observed: "Проверен", stale: "Проверка устарела",
			status: {unknown: "Неизвестно", healthy: "Работает", unhealthy: "Не работает"},
			reasonValues: {unknown: "Нет подтверждённой проверки", ok: "Проверка успешна", timeout: "Тайм-аут", transport: "Ошибка соединения", configuration: "Ошибка конфигурации", authentication: "Ошибка аутентификации", provider_unavailable: "Провайдер недоступен", invalid_response: "Некорректный ответ"},
		},
		states: {
			loadingTitle: "Загружаем состояние адаптеров", loadingBody: "Получаем актуальный control plane у владельца данных.",
			emptyTitle: "Адаптеров пока нет", emptyBody: "Владелец не вернул ни одного зарегистрированного адаптера.",
			unauthenticatedTitle: "Сессия завершена", unauthenticatedBody: "Войдите снова, прежде чем управлять адаптерами.",
			forbiddenTitle: "Нет доступа к адаптерам", forbiddenBody: "Раздел доступен только администратору и суперадминистратору. Сервер повторно проверяет каждую команду.",
			not_foundTitle: "Адаптер не найден", not_foundBody: "Адаптер удалён или опубликованный список уже изменился.",
			validationTitle: "Проверьте данные", validationBody: "Владелец отклонил форму или выбранный набор возможностей.",
			conflictTitle: "Control plane уже изменился", conflictBody: "Черновик отброшен. Перечитайте актуальную версию перед новой командой.",
			dependency_unavailableTitle: "Владелец временно недоступен", dependency_unavailableBody: "Результат команды может быть неопределён. Повтор использует тот же ключ и те же данные.",
			integrityTitle: "Целостность ответа не подтверждена", integrityBody: "Интерфейс остановил показ ответа, который не соответствует безопасному контракту.",
		},
		payments: {
			eyebrow: "Payments control plane", title: "Платёжные адаптеры", lead: "Manifest, persisted policy, health и покрытие показаны раздельно; режим и runtime-готовность не вычисляются браузером.",
			registryEyebrow: "Реестр Payments", registryTitle: "Установленные и сохранённые провайдеры", capabilities: "Возможности manifest", credentials: "Credential slots", noCredentialSlots: "Этому manifest не нужны credential slots.",
			callback: "Callback", poll: "Polling", terminalContract: "Terminal contract", identityVersion: "Версия identity операции", removedManifest: "Manifest больше не установлен. Сохранённая политика показана только для чтения.",
			enable: "Настроить и включить", disable: "Выключить", enableEyebrow: "Точный capability subset", enableTitle: "Включить {{name}}?", enableBody: "Будет отправлен только выбранный непустой набор и наблюдаемая версия политики {{version}}. Режим адаптера не меняется.", confirmEnable: "Включить выбранное", disableEyebrow: "Остановка новых операций", disableTitle: "Выключить {{name}}?", disableBody: "Новые операции перестанут назначаться провайдеру. Уже созданные попытки продолжат terminal convergence с исходным ProviderRef.", confirmDisable: "Выключить адаптер",
			coverageEyebrow: "Owner-computed матрица", coverageTitle: "Покрытие активных валют", catalogUnavailableTitle: "Каталог валют недоступен", catalogUnavailableBody: "Пустой список не считается подтверждённым покрытием. Повторите чтение после восстановления источника.", currency: "Валюта", scenario: "Сценарий", configured: "Настроенные ProviderRef", available: "Runtime-доступные ProviderRef", gap: "Разрыв",
		},
		telephony: {
			eyebrow: "Consultations control plane", title: "Телефонные адаптеры", lead: "Выбор active ref, конфигурация, health и runtime availability показаны как независимые координаты владельца.",
			rootVersion: "Версия control plane", evidenceTitle: "Active — не доказательство звонка", evidenceBody: "Выбранный адаптер может быть runtime-недоступен. Реальный звонок подтверждается только CallSession и provider evidence; этот экран не запускает тестовые вызовы.",
			registryEyebrow: "Реестр Consultations", registryTitle: "Установленные и сохранённые конфигурации", availabilityReason: "Причина runtime availability", mode: "Неизменяемый режим", configurationVersion: "Версия конфигурации", configurationUpdated: "Конфигурация обновлена", endpoint: "Endpoint", healthSupported: "Health probe поддерживается", healthUnsupported: "Health probe не поддерживается", healthConfigurationVersion: "проверена конфигурация v{{version}}",
			makeCallContract: "Make-call contract", callbackContract: "Callback contract", signatureContract: "Signature contract", credentialSlots: "Binding aliases", zeroSlots: "Manifest не объявляет credential slots; конфигурация содержит только endpoint.", removedManifest: "Manifest больше не установлен. Сохранённая конфигурация показана только для чтения.",
			configure: "Настроить", activate: "Выбрать active", deactivate: "Снять active", configureEyebrow: "Полная замена конфигурации", configureTitle: "Настроить {{name}}", configureBody: "Endpoint и полный набор alias отправятся с текущей корневой версией {{version}}. Секреты здесь не вводятся.", confirmConfigure: "Сохранить конфигурацию", activateEyebrow: "Атомарный выбор", activateTitle: "Выбрать {{name}}?", activateBody: "Consultations атомарно заменит active ref по корневой версии {{version}}; отдельная деактивация прежнего адаптера не выполняется.", confirmActivate: "Выбрать адаптер", deactivateEyebrow: "Снять выбор", deactivateTitle: "Деактивировать телефонию?", deactivateBody: "Active ref будет очищен, но endpoint, binding aliases и ревизии конфигурации сохранятся.", confirmDeactivate: "Снять active",
		},
	},
	finance: {
		nav: {root: "Финансы", accounts: "Кошельки", payments: "Платежи", refunds: "Возвраты", guest: "Гостевые возвраты", reports: "Отчёты"},
		readOnly: "Только просмотр",
		unknownClosedValue: "Неизвестное состояние",
		sectionNavigationAria: "Разделы финансового back-office",
		fixtureScenario: "Сценарий финансового ревью",
		scenarios: {
			normal: "Обычные данные", empty: "Пустые данные", loading: "Долгая загрузка",
			dependency_unavailable: "Источник не подключён", finance_unavailable: "Проекция недоступна",
			incomplete: "Неполные данные", stale: "Отстающие данные", integrity: "Ошибка целостности",
			validation: "Некорректный запрос", feature_disabled: "Маршрут выключен", forbidden: "Нет доступа",
		},
		filtersAria: "Фильтры финансовой выдачи",
		queueFreshnessAria: "Актуальность источников финансовой очереди",
		paginationAria: "Навигация по финансовой выдаче",
		pendingNavigationBlocked: "Переход по ссылкам заблокирован до завершения или явной отмены этой защищённой попытки.",
		states: {
			loadingTitle: "Загружаем финансовую выдачу",
			loadingDetailTitle: "Загружаем финансовую карточку",
			loadingBody: "Получаем подтверждённый снимок у владельца данных.",
			unauthenticatedTitle: "Сессия завершена",
			unauthenticatedBody: "Войдите снова, прежде чем открывать финансовые данные.",
			forbiddenTitle: "Нет доступа к финансам",
			forbiddenBody: "Финансовый раздел доступен только финансовому менеджеру, администратору или суперадминистратору.",
			not_foundTitle: "Финансовая запись не найдена",
			not_foundBody: "Запись отсутствует в подтверждённом снимке или адрес устарел.",
			feature_disabledTitle: "Финансовый маршрут пока выключен",
			feature_disabledBody: "BFF ещё не публикует эту возможность. Интерфейс не подменяет её локальным действием и не повторяет запрос автоматически.",
			validationTitle: "Проверьте параметры финансового запроса",
			validationBody: "Фильтр, идентификатор или продолжение страницы не прошли проверку владельца.",
			conflictTitle: "Финансовое состояние уже изменилось",
			conflictBody: "Карточка перечитана. Проверьте актуальную версию и подтвердите действие заново.",
			adjustment_not_allowedTitle: "Корректировка отклонена",
			adjustment_not_allowedBody: "Текущий кошелёк не допускает эту сумму или направление. Баланс не изменён.",
			dependency_unavailableTitle: "Источник финансов не подключён",
			dependency_unavailableBody: "Один из владельцев данных или его маршрут сейчас недоступен. Подмена тестовыми данными выключена.",
			finance_unavailableTitle: "Финансовые данные ещё не готовы",
			finance_unavailableBody: "Снимок, проекция или отчёт не подтверждают полную выдачу. Пустое значение не показывается как ноль.",
			integrityTitle: "Целостность данных не подтверждена",
			integrityBody: "Интерфейс остановил показ финансовых фактов из несогласованных источников.",
			export_incompleteTitle: "Выгрузка слишком велика",
			export_incompleteBody: "Сузьте фильтры: полный CSV не помещается в ограничение по строкам или размеру.",
			report_run_changedTitle: "Отчёт обновился",
			report_run_changedBody: "Появился новый гостевой запуск. Обновите отчёт и повторите выгрузку по его точному номеру.",
		},
		empty: {
			walletsTitle: "Кошельков пока нет", walletsBody: "Billing не вернул ни одного существующего кошелька этого аккаунта.",
			paymentsTitle: "Платежей не найдено", paymentsBody: "В подтверждённом снимке нет платежей с выбранными фильтрами.",
			refundsTitle: "Возвратов не найдено", refundsBody: "В подтверждённом снимке нет возвратов с выбранными фильтрами.",
			guestTitle: "Строк отчёта нет", guestBody: "Полный terminal-отчёт не содержит обязательств с выбранными фильтрами.",
		},
		notices: {
			incompleteTitle: "Данные неполные",
			incompleteBody: "Один или несколько источников не подтвердили покрытие. Отсутствующие строки не считаются нулём.",
		},
		freshness: {
			ready: "Снимок подтверждён · {{date}}", lagging: "Источник отстаёт · {{date}}",
			sources: {billing: "Billing", payments: "Payments", billing_application: "Применение Billing · прежние операции", billing_application_converted: "Применение Billing · конвертация"},
		},
		status: {
			payment: {pending: "Ожидает оплаты", succeeded: "Оплачен", failed: "Ошибка оплаты"},
			operational: {create_pending: "Создание", confirmation_required: "Нужно подтверждение", provider_processing: "У провайдера", attention: "Требует внимания", operator_required: "Нужен оператор", terminal: "Завершён"},
			application: {not_applicable: "Не применяется", not_applied: "Не применён", applied: "Применён"},
			refund: {requested: "Запрошен", approved: "Одобрен", executed: "Исполнен", rejected: "Отклонён"},
			guest: {complete: "Полный", incomplete: "Неполный", failed: "Ошибка отчёта", no_coverage: "Нет покрытия"},
		},
		filters: {all: "Все", period: "Период", purpose: "Назначение", paymentPhase: "Фаза платежа", operationalPhase: "Операционная фаза", applicationPhase: "Применение в Billing", refundStatus: "Статус возврата", route: "Маршрут", currency: "Валюта", provider: "ProviderRef", accountId: "Account ID", orderRef: "OrderRef", paymentIntentId: "PaymentIntent ID", sourceKind: "Тип источника", reason: "Основание", direction: "Направление", operation: "Операция", evidence: "Тип доказательства"},
		period: {last_30_days: "Последние 30 дней", all_history: "Вся история"},
		direction: {credit: "Зачисление", debit: "Списание"},
		evidence: {ledger_entry: "Запись ledger", legacy_wallet_movement: "Историческое движение"},
		purpose: {top_up_wallet: "Пополнение кошелька", cover_order: "Оплата заказа"},
		route: {consultation: "Консультация", service: "Услуга"},
		operation: {consultation: "Консультация", service: "Услуга", invoice: "Счёт", transfer: "Перевод", answer: "Ответ", refund: "Возврат", adjustment: "Корректировка", payout: "Выплата", earning: "Начисление", opening_balance: "Начальный баланс", payment_top_up: "Пополнение платежом"},
		sourceKind: {consultation_terminal: "Результат консультации", booking_no_show: "Неявка на бронирование", service_cancelled: "Отмена услуги"},
		reason: {completed_unused: "Неиспользованный остаток", client_request: "Запрос клиента", expert_unavailable: "Эксперт недоступен", admin_override: "Решение администратора", account_lifecycle: "Состояние аккаунта", technical_failure: "Технический сбой", payment_compensated: "Платёж компенсирован", client_no_show: "Неявка клиента", service_cancelled: "Услуга отменена"},
		adjustmentReason: {accounting_correction: "Бухгалтерская корректировка", customer_compensation: "Компенсация клиенту", dispute_resolution: "Урегулирование спора", payout_correction: "Корректировка выплаты"},
		referenceKind: {order_ref: "OrderRef", payment_intent_id: "PaymentIntent ID", refund_ref: "RefundRef", payout_id: "Payout ID", ledger_transaction_id: "Ledger transaction ID"},
		rejectReason: {ineligible_evidence: "Недостаточные доказательства", duplicate_outcome: "Повторный исход", policy_denied: "Запрещено политикой", operator_decision: "Решение оператора"},
		paymentFailure: {declined: "Отклонён", cancelled: "Отменён", provider_rejected: "Провайдер отклонил", expired: "Истёк"},
		funding: {clearing: "Клиринг", risk: "Резерв риска", no_money_due: "Деньги не требуются"},
		actions: {eyebrow: "Разрешённые действия", title: "Действия владельца", approve: "Одобрить", reject: "Отклонить", none: "Владелец не разрешил ни одного действия.", readOnly: "Действия определяет Billing.", rejectReason: "Причина отклонения", confirmTitle: "Подтвердить решение", confirmApprove: "Одобрить возврат по версии {{version}}?", confirmReject: "Отклонить возврат по версии {{version}}?", confirm: "Подтвердить"},
		notFound: {title: "Такой финансовой страницы нет", body: "Проверьте точный адрес ресурса или вернитесь к очереди платежей.", action: "Открыть платежи"},
		account: {
			eyebrow: "Финансы аккаунта", title: "Аккаунт {{id}}", short: "Аккаунт {{id}}", lead: "Общий баланс и подтверждённая история движения денег.", walletsAria: "Баланс аккаунта", open: "Открыть финансы аккаунта", walletVersion: "Версия {{version}}", held: "Удержано", available: "Доступно", availableShort: "доступно",
			ledgerEyebrow: "История кошелька", ledgerTitle: "Операции", ledgerEmpty: "У кошелька нет операций в подтверждённом периоде.", legacyEvidence: "Историческое движение",
			adjustmentEyebrow: "Ручная корректировка", adjustmentTitle: "Корректировка баланса", adjustmentReadOnly: "Баланс меняется только после подтверждения Billing.", adjustmentLead: "Сумма отправляется как точные minor units; баланс меняется только после ответа Billing.", adjustmentAction: "Проверить корректировку", amount: "Сумма", direction: "Направление", reason: "Закрытое основание", referenceKind: "Тип ссылки", reference: "Точная ссылка", confirmTitle: "Подтвердить корректировку", confirmAction: "Выполнить корректировку", adjustmentSaved: "Корректировка подтверждена Billing", before: "Баланс до", after: "Баланс после",
		},
		payments: {
        providerAmount: "Оплата у провайдера", convertedAmount: "Сумма после конвертации",
			eyebrow: "Глобальная финансовая очередь", title: "Платежи", lead: "Платёж, операционное состояние и применение в Billing показаны раздельно.", queueEyebrow: "Подтверждённый снимок", queueTitle: "Очередь платежей", back: "К платежам", detailEyebrow: "Платёж", detailTitle: "Карточка платежа",
			purpose: "Назначение", attempt: "Попытка", provider: "Провайдер", providerRef: "ProviderRef", providerFamily: "Семейство провайдера", providerMode: "Режим провайдера", policyVersion: "Версия политики", failure: "Причина ошибки", initialized: "Инициализирован", attemptStarted: "Попытка начата", updated: "Обновлён", terminal: "Завершён", boundedFilteredPage: "На этой bounded-странице нет строк после application-фильтра. Продолжите frozen cursor: следующие кандидаты не были просмотрены.", filteredContinuationEnd: "На этой странице нет строк после application-фильтра и следующих кандидатов нет. Можно вернуться к предыдущей странице frozen-выдачи.",
		},
		refunds: {
			eyebrow: "Решения Billing", title: "Возвраты", lead: "Очередь возвратов с owner-computed состоянием и разрешёнными действиями.", queueEyebrow: "Подтверждённый снимок", queueTitle: "Очередь возвратов", itemTitle: "Возврат {{id}}", account: "Аккаунт {{id}}", version: "версия {{version}}", back: "К возвратам", detailEyebrow: "Возврат", detailTitle: "Карточка возврата",
			recipient: "Аккаунт получателя", source: "Источник", reason: "Основание", requestedAt: "Запрошен", updatedAt: "Обновлён", versionLabel: "Версия", funding: "Источник покрытия", base: "Основная сумма", fee: "Комиссия", decisionAt: "Решение принято", decisionActor: "Account решения", rejectReason: "Причина отклонения", terminalAt: "Исполнен", ledgerTransaction: "Ledger transaction", continuationEnd: "В этой frozen-странице строк нет. Можно вернуться к предыдущей странице.",
		},
		guest: {
			eyebrow: "Terminal-отчёт", title: "Гостевые возвраты", lead: "Последний неизменяемый отчёт и обязательства без ручной подмены доказательств.", manifestEyebrow: "Покрытие источников", manifestTitle: "Последний завершённый отчёт", run: "Запуск", cutoff: "Срез на", completed: "Завершён", coverageAria: "Покрытие отчёта", sources: {owner: "Owner-источник", payment: "Платёжный источник"}, coverage: {complete: "полный", incomplete: "неполный", failed: "ошибка", no_coverage: "нет покрытия"}, failureCategory: {source_not_admitted: "источник не допущен", coverage_incomplete: "покрытие неполное", terminal_failed: "terminal-запуск завершился ошибкой"}, summaryAria: "Итоги полного гостевого отчёта", obligationCount_one: "{{count}} обязательство", obligationCount_few: "{{count}} обязательства", obligationCount_many: "{{count}} обязательств", obligationCount_other: "{{count}} обязательства",
			openObligations: "Открыть строки отчёта", listEyebrow: "Frozen-снимок отчёта", listTitle: "Гостевые обязательства", runBoundLead: "Строки terminal-отчёта {{id}}. Текущая settlement-готовность здесь не вычисляется.", snapshotEyebrow: "Неизменяемые строки", snapshotTitle: "Обязательства отчёта", itemTitle: "Обязательство {{id}}", sourceAt: "Источник на", createdAt: "Обязательство создано", back: "К гостевому отчёту", continuationEnd: "В этой frozen-странице строк нет. Можно вернуться к предыдущей странице.",
		},
		reports: {
			eyebrow: "Финансовые срезы", title: "Отчёты", lead: "Итоги считают Payments и Billing по своим подтверждённым снимкам. Выгрузка получает собственный срез.",
			kindAria: "Выбор финансового отчёта", kinds: {payments: "Активность платежей", refunds: "Возвраты Account", guest: "Гостевые обязательства"},
			totalCount: "Количество", count: "{{total}} записей", paymentMeaning: "Один PaymentIntent считается один раз; сумма показана только для успешных платежей.", refundMeaning: "Один Refund считается один раз; сумма показана только для исполненных возвратов. Нулевое исполнение входит в количество.",
			window: "Период: {{start}} — {{end}}", allHistory: "начало истории", groupsAria: "Группы отчёта по валютам", emptyTitle: "Совпадений нет", emptyBody: "Источник подтвердил полный срез; по выбранным фильтрам записей нет.",
			succeededAmount: "Сумма успешных платежей", executedAmount: "Сумма исполненных возвратов", guestAmount: "Сумма открытых обязательств",
			guestRun: "Запуск гостевого отчёта", guestIncompleteTitle: "Покрытие не подтверждено", guestIncompleteBody: "Гостевой отчёт неполный. Его отсутствие строк не означает нулевой остаток; выгрузка недоступна.",
			coverageSources: {owner: "Источник заказов", payment: "Источник платежей"},
			sourcesAria: "Срезы владельцев данных", sources: {payments: "Payments", billing_refunds: "Billing Refund", billing_application: "Применение Billing · прежние операции", billing_application_converted: "Применение Billing · конвертация"},
			readiness: "Источник готов · срез полный", calculatedAt: "Расчёт на", asOf: "Позиция среза", operationalAsOf: "Операционная позиция Payments", highWater: "Верхняя граница источника", operationalHighWater: "Операционная граница Payments", projectionVersion: "Версия проекции", projectionGeneration: "Поколение проекции", buildId: "Сборка проекции",
			exportTitle: "Полная ограниченная выгрузка", exportLead: "CSV содержит все строки подтверждённого frozen-среза до лимита 10 000 строк и 8 MiB. Его срез может отличаться от показанного итога.", export: "Скачать CSV", exporting: "Готовим CSV…", exportReady: "CSV скачан", exportOwnCutoff: "Срез скачанного файла:",
		},
	},
	commercial: {
		crumb: "Условия эксперта {{id}}",
		actionColumn: "Коммерческие условия",
		open: "Открыть условия",
		back: "К списку экспертов",
		eyebrow: "Эксперт · ID {{id}}",
		title: "Тариф и индивидуальные комиссии",
		lead: "Тариф и весь набор индивидуальных правил сохраняются одной атомарной командой Marketplace.",
		profileVersion: "Версия профиля",
		sourcesAria: "Источники коммерческой формы",
		sources: {
			terms: "Условия Marketplace",
			currencies: "Активные валюты",
			settings: "Глобальные комиссии",
			termsVersion: "версия профиля {{version}}",
			currencyCount: "активных записей: {{count}}",
			settingCount: "доступных настроек: {{count}}",
			loading: "загрузка…",
			error: "источник недоступен",
			ready: "данные получены",
		},
		tariffEyebrow: "Точная сумма",
		tariffTitle: "Тариф эксперта",
		perMinute: "за минуту",
		missingTariffTitle: "Тариф ещё не задан",
		missingTariffBody: "Это legacy-профиль. Первая запись всё равно проверит текущую версию профиля {{version}}.",
		amountLabel: "Сумма за минуту",
		amountHelp: "До двух знаков после точки; сумма переводится в minor units без float.",
		currencyLabel: "Активная валюта",
		currencyPlaceholder: "Выберите валюту",
		currencyInactive: "{{code}} — больше не активна",
		commissionsEyebrow: "Пять операций",
		commissionsTitle: "Доли эксперта и платформы",
		commissionsLead: "Выключенное индивидуальное правило использует показанную глобальную настройку. Ноль — явное значение, а не отсутствие.",
		openFinance: "Открыть глобальные настройки",
		operations: {consultation: "Консультация", service: "Услуга", invoice: "Счёт", transfer: "Перевод", answer: "Ответ"},
		individualToggle: "Индивидуальная доля",
		expertShareLabel: "Доля эксперта",
		expertShort: "Эксперт",
		platformShort: "Платформа",
		globalFallback: "Глобальная настройка",
		globalUnconfigured: "Глобальная настройка не сконфигурирована",
		fallbackLoading: "Загружаем глобальную настройку…",
		fallbackUnavailable: "Источник глобальных настроек недоступен; значение не подменено default.",
		fallbackMissing: "Для выбранной валюты нет доступной глобальной настройки.",
		sourceVersion: "версия Setting {{version}}",
		invalidShare: "Значение доли недоступно",
		validation: {
			amount: "Введите положительную сумму максимум с двумя знаками после точки.",
			currency: "Выберите валюту из актуального активного справочника.",
			override: "Каждая включённая доля должна быть от 0 до 100% максимум с двумя знаками после точки.",
		},
		atomicTitle: "Одна команда — одна версия",
		atomicBody: "Глобальные настройки этим сохранением не изменяются.",
		reviewSave: "Проверить и сохранить",
		confirmEyebrow: "Атомарная замена",
		confirmTitle: "Сохранить коммерческие условия?",
		confirmBody: "Тариф {{amount}} {{currency}}/мин и {{count}} индивидуальных правил заменят текущие условия целиком.",
		confirmSave: "Сохранить условия",
		savedTitle: "Условия сохранены",
		savedBody: "Marketplace вернул актуальную версию профиля {{version}}.",
		reloaded: {
			conflictTitle: "Условия уже изменились",
			conflictBody: "Все три источника перечитаны; проверьте форму с актуальной версией.",
			validationTitle: "Владелец отклонил актуальность данных",
			validationBody: "Форма и активные валюты перечитаны без подстановки прежних значений.",
		},
	},
	platform: {
		nav: {settings: "Настройки", dictionaries: "Справочники", phone: "Стоп-лист телефонов"},
		loadMore: "Показать ещё",
		loadingMore: "Загружаем…",
		reasonLabel: "Основание изменения",
		reasonBytes: "{{count}} из 2000 байт",
		save: "Сохранить",
		edit: "Изменить",
		states: {
			loadingTitle: "Загрузка",
			loadingBody: "Загружаем актуальные данные владельца…",
			emptyTitle: "Записей пока нет",
			emptyBody: "Для этого раздела владелец не вернул ни одной записи.",
			forbiddenTitle: "Нет доступа",
			forbiddenBody: "У вашей роли нет права просматривать или изменять этот раздел.",
			not_foundTitle: "Запись не найдена",
			not_foundBody: "Запись отсутствует или уже недоступна.",
			validationTitle: "Проверьте данные",
			validationBody: "Значение или основание изменения не прошло проверку.",
			conflictTitle: "Версия уже изменилась",
			conflictBody: "Актуальные данные перечитываются. Повторите действие с новой версией.",
			unavailableTitle: "Сервис временно недоступен",
			unavailableBody: "Владелец данных не ответил. Повторите запрос через несколько секунд.",
			internalTitle: "Не удалось выполнить запрос",
			internalBody: "Повторите запрос или передайте номер обращения в поддержку.",
		},
		settings: {
			eyebrow: "Настройки платформы",
			title: "Настройки: {{area}}",
			lead: "Каждый параметр сохраняется отдельно с проверкой актуальной версии.",
			areasAria: "Области настроек",
			areas: {system: "Система", content: "Контент", finance: "Финансы", security: "Безопасность"},
			kycTitle: "KYC-гейты редактируются отдельно",
			kycBody: "Пять продуктовых правил сохраняют собственный интерфейс и подтверждение.",
			staleTitle: "Настройка уже изменилась",
			staleBody: "Черновик закрыт, актуальная версия перечитывается.",
			editTitle: "Изменить настройку",
			riskWarning: "Это защитная настройка. Проверьте значение и подробно укажите основание.",
			valueHelp: "Введите значение в формате, указанном для типа настройки.",
			valueLabel: "Новое значение",
			listPlaceholder: "Одно значение на строку",
			durationHint: "Например: 30s, 5m или 1h30m",
			configured: "Настроено",
			unconfigured: "Не настроено",
			noValue: "Значение ещё не задано",
			kind: "Тип",
			version: "Версия",
			default: "По умолчанию",
			range: "Диапазон",
			allowed: "Допустимые значения",
			moneyNote: "Показывается как точная сумма с двумя знаками; владелец хранит minor units.",
			bpsNote: "Значение показано и редактируется в процентах: 1.00% = 100 базисных пунктов (basis points) в реестре.",
			financeTitles: {
				minimumTopUp: "Минимальная сумма пополнения — {{currency}}",
				minimumTransfer: "Минимальная сумма перевода — {{currency}}",
				reviewEligibilityThreshold: "Порог оплаченной суммы для отзыва — {{currency}}",
				consultationExpertShare: "Глобальная доля эксперта за консультацию — {{currency}}",
				serviceExpertShare: "Глобальная доля эксперта за услугу — {{currency}}",
				invoiceExpertShare: "Глобальная доля эксперта по счёту — {{currency}}",
				transferExpertShare: "Глобальная доля эксперта при переводе — {{currency}}",
				answerExpertShare: "Глобальная доля эксперта за ответ — {{currency}}",
				noShowRefundFee: "Комиссия возврата при неявке клиента — {{currency}}",
			},
			titles: {
				qnaEnabled: "Сценарии Q&A",
				servicesEnabled: "Сценарии услуг",
				emailEnabled: "Доставка email-уведомлений",
				smsEnabled: "Доставка SMS-уведомлений",
				smsSandbox: "Sandbox-режим SMS",
				notificationMaxAttempts: "Максимальное число попыток доставки",
				chatMessageCatchupDelay: "Задержка email-напоминания о сообщении в чате",
				bookingUnpaidReminderLead: "Опережение напоминания об оплате брони",
				bookingUpcomingReminderLead: "Опережение напоминания о предстоящей консультации",
				bookingReservationTtl: "Срок жизни неоплаченной брони",
				consultationDraftOrderTtl: "Срок жизни черновика заказа консультации",
				otpResendInterval: "Минимальный интервал между выдачами OTP",
				otpMaxAttempts: "Максимальное число попыток ввода OTP",
				otpGuestProofTtl: "Срок действия подтверждённого телефона гостя",
				otpGuestRequestWindow: "Окно лимитов выдачи гостевого OTP",
				otpGuestMaxRequestsPerPhone: "Максимум выдач гостевого OTP на телефон",
				otpGuestMaxRequestsPerIp: "Максимум выдач гостевого OTP на IP",
				otpGuestMaxRequestsPerSession: "Максимум выдач гостевого OTP на GuestIdentity",
				authBruteForceMaxFailures: "Число ошибок учётных данных до обязательной CAPTCHA",
				authBruteForceFailureWindow: "Окно накопительной защиты проверок учётных данных",
				authBruteForceCaptchaTtl: "Минимальный срок обязательной CAPTCHA после ошибки учётных данных",
				passwordResetRequestLimit: "Максимум запросов на восстановление пароля",
				passwordResetRequestWindow: "Окно лимита запросов на восстановление пароля",
				passwordResetCodeMaxAttempts: "Максимум попыток ввода кода восстановления",
				commentAntiSpamMinSubmitDelay: "Минимальное время заполнения формы комментария",
				commentAntiSpamIpMinInterval: "Минимальный интервал между попытками комментария с одного IP",
				commentAntiSpamIpHourlyLimit: "Максимум попыток комментария с одного IP в час",
				commentAntiSpamMinLength: "Минимальная длина комментария",
				commentAntiSpamMaxLength: "Максимальная длина комментария",
				commentAntiSpamBlockedPatterns: "Запрещённые подстроки в комментариях",
			},
			kinds: {bool: "Логическое", int: "Целое число", decimal: "Десятичное", string: "Строка", duration: "Длительность", string_list: "Список строк"},
			validation: {
				format: "Проверьте формат значения.",
				minimum: "Значение меньше допустимого минимума.",
				maximum: "Значение больше допустимого максимума.",
				allowed: "Выберите одно из допустимых значений.",
				cross_range: "Сначала расширьте границу: minimum не может быть больше maximum.",
			},
		},
		dictionaries: {
			eyebrow: "Публичные данные платформы",
			lead: "Записи публикуются полным типизированным снимком; физическое удаление недоступно.",
			typesAria: "Типы справочников",
			types: {currencies: "Валюты", countries: "Страны", call_durations: "Длительности звонков", specializations: "Специализации"},
			create: "Добавить запись",
			currencyWarning: "Rate и markup не выполняют денежную конвертацию. Активация записи не подтверждает готовность финансовых адаптеров и настроек.",
			durationWarning: "Активной текущей promo-длительностью может быть только одна запись; ноль допустим.",
			includeInactive: "Показывать неактивные",
			createTitle: "Новая запись",
			editTitle: "Изменить запись",
			key: "Неизменяемый ключ",
			sortOrder: "Порядок сортировки",
			active: "Активна",
			statusActive: "Активна",
			statusInactive: "Неактивна",
			meta: "Порядок {{sort}} · версия {{version}}",
			summaries: {
				currency: "{{name}} · {{symbol}} · ставка {{rate}} · наценка {{markup}}",
				country: "{{name}} · {{callingCode}}",
				callDuration: "{{minutes}} мин · стандарт: {{standard}} · промо: {{promo}}{{current}}",
				currentPromo: " · текущая промо",
				specialization: "{{name}} · {{slug}} · ID {{id}}",
			},
			deactivateTitle: "Деактивировать запись?",
			deactivateBody: "Запись «{{key}}» останется в истории, но перестанет быть активной.",
			deactivate: "Деактивировать",
			fields: {code: "Код", nameRu: "Название на русском", symbol: "Символ", rate: "Rate", markup: "Markup", callingCode: "Телефонный код", minutes: "Минуты", standard: "Доступна для standard", promo: "Доступна для promo", currentPromo: "Текущая promo", id: "Числовой ID", slug: "Slug"},
			validation: {key: "Укажите ключ записи.", sort: "Порядок должен быть безопасным целым числом.", value: "Заполните поля в допустимом формате.", currentPromo: "Другая активная запись уже выбрана текущей promo-длительностью."},
		},
		phone: {
			eyebrow: "Приватный контур",
			title: "Стоп-лист телефонов",
			lead: "Точные номера и основания доступны только владельцу и не сохраняются в адресе или браузерном хранилище.",
			searchLabel: "Точный номер в E.164",
			searchPlaceholder: "+<код страны><номер>",
			search: "Найти",
			searching: "Ищем…",
			privateNote: "Поиск отправляет номер только в теле приватного запроса. Список маскирует номер до явного раскрытия.",
			notFoundTitle: "Номер не найден",
			notFoundBody: "Для точного номера ещё нет записи. Его можно добавить в стоп-лист.",
			block: "Заблокировать",
			reactivate: "Заблокировать снова",
			unblock: "Снять блокировку",
			blockTitle: "Добавить номер в стоп-лист?",
			blockBody: "Номер будет заблокирован владельцем. Точное значение не попадёт в результат операции.",
			unblockTitle: "Снять блокировку?",
			unblockBody: "Запись останется в приватной истории, изменятся статус и версия.",
			statusBlocked: "Заблокирован",
			statusInactive: "Неактивен",
			reveal: "Показать точный номер",
			hide: "Скрыть точный номер",
			listAria: "Приватный список телефонов",
			blockReason: "Основание блокировки",
			lastReason: "Последнее основание",
			changedAt: "Изменён",
		},
	},
	kyc: {
		nav: "Проверка KYC",
		settingsNav: "KYC-гейты",
		openQueue: "Открыть очередь KYC",
		caseShort: "Кейс {{id}}",
		queueEyebrow: "Проверка документов",
		queueTitle: "Очередь KYC",
		queueLead: "Заявки экспертов на проверку личности и приложенные документы.",
		filtersAria: "Фильтры очереди KYC",
		statusFilter: "Статус",
		allStatuses: "Все",
		statuses: {submitted: "На проверке", approved: "Одобрено", rejected: "Отклонено"},
		scenarios: {normal: "Обычная очередь", empty: "Пустая очередь", error: "Ошибка сервиса", forbidden: "Нет доступа"},
		loadingQueue: "Загружаем очередь KYC",
		loadingDetail: "Загружаем кейс KYC",
		emptyTitle: "Очередь пуста",
		emptyBody: "Заявок с выбранным статусом сейчас нет.",
		casesShown_one: "Показан {{count}} кейс",
		casesShown_few: "Показано {{count}} кейса",
		casesShown_many: "Показано {{count}} кейсов",
		casesShown_other: "Показано {{count}} кейса",
		privateNote: "Документы открываются только по явному запросу",
		expert: "Эксперт",
		case: "Кейс",
		status: "Статус",
		documents: "Документы",
		submitted: "Отправлен",
		documentCount_one: "{{count}} документ",
		documentCount_few: "{{count}} документа",
		documentCount_many: "{{count}} документов",
		documentCount_other: "{{count}} документа",
		paginationAria: "Навигация по страницам очереди KYC",
		backToQueue: "К очереди KYC",
		caseEyebrow: "KYC-кейс № {{number}}",
		documentsEyebrow: "Конфиденциальные данные",
		documentsTitle: "Документы заявки",
		openDocument: "Открыть",
		openingDocument: "Получаем доступ…",
		accessExpires: "Доступ действует до {{date}}",
		decisionEyebrow: "Решение оператора",
		decisionTitle: "Результат проверки",
		approve: "Одобрить",
		reject: "Отклонить",
		approveTitle: "Одобрить KYC?",
		rejectTitle: "Отклонить KYC?",
		decisionBody: "Эксперт {{name}}, кейс № {{number}}. Решение сохранится в аудите.",
		reasonLabel: "Основание решения",
		reasonBytes: "{{count}} из 2000 байт",
		alreadyDecided: "Решение принято {{date}}, оператор ID {{id}}.",
		auditEyebrow: "Версии и аудит",
		auditTitle: "Служебные данные",
		caseId: "ID кейса",
		statusVersion: "Версия статуса",
		decisionReason: "Основание",
		staleReloaded: "Данные изменились в другой сессии. Актуальная версия уже перечитывается.",
		settingsEyebrow: "Политика KYC",
		settingsTitle: "Продуктовые KYC-гейты",
		settingsLead: "Каждое правило независимо определяет, нужен ли approved KYC для продуктового сценария.",
		readOnlyTitle: "Режим только для чтения",
		financeReadOnly: "Финансовый менеджер видит правила, но изменять их могут только admin и super_admin.",
		gateRequired: "KYC обязателен",
		gateDisabled: "Гейт выключен",
		disableGate: "Выключить",
		enableGate: "Включить",
		disableGateTitle: "Выключить KYC-гейт?",
		enableGateTitle: "Включить KYC-гейт?",
		gateConfirmBody: "Правило «{{name}}» изменится сразу после подтверждения.",
		confirmGate: "Подтвердить изменение",
		gates: {
			catalogTitle: "Публикация в каталоге", catalogBody: "Требовать approved KYC перед публикацией эксперта.",
			voiceTitle: "Голосовые консультации", voiceBody: "Требовать approved KYC для голосовых консультаций.",
			servicesTitle: "Заказы услуг", servicesBody: "Требовать approved KYC для заказов экспертных услуг.",
			payoutsTitle: "Выплаты", payoutsBody: "Требовать approved KYC перед проведением выплат.",
			testModeTitle: "Тестовые операции", testModeBody: "Требовать approved KYC для rehearsal и тестовых операций.",
		},
		errors: {
			forbiddenTitle: "Нет доступа к KYC", forbiddenBody: "У вашей роли нет права просматривать или изменять эти данные.",
			not_foundTitle: "KYC-кейс не найден", not_foundBody: "Возможно, кейс удалён или ссылка устарела.",
			validationTitle: "Проверьте данные", validationBody: "Параметры запроса или основание решения не прошли проверку.",
			conflictTitle: "Версия уже изменилась", conflictBody: "Перечитайте актуальные данные и повторите действие.",
			unavailableTitle: "KYC временно недоступен", unavailableBody: "Сервис не ответил. Повторите запрос через несколько секунд.",
			internalTitle: "Не удалось загрузить KYC", internalBody: "Повторите запрос или передайте номер обращения в поддержку.",
		},
	},
  },
  errors: {
    required: "Заполните поле",
    contactRequired: "Укажите email или телефон.",
    passwordMismatch: "Пароли не совпадают",
    otpFormat: "Введите ровно 6 цифр.",
    otpInvalid: "Неверный код. Проверьте SMS и попробуйте ещё раз.",
    otpExhausted: "Попытки ввода исчерпаны. Запросите новый код.",
    otpExpired: "Код истёк или уже недоступен. Запросите новый код.",
    otpResendEarly: "Новый код пока нельзя отправить. Дождитесь окончания таймера.",
    phoneTaken: "Этот номер уже принадлежит другому активному аккаунту.",
    fieldInvalid: "Проверьте значение поля",
    validation: "Проверьте правильность заполнения формы.",
    invalidCredentials: "Неверный email или пароль.",
    alreadyExists: "Аккаунт с такими данными уже существует.",
    confirmationInvalid: "Ссылка подтверждения недействительна или устарела.",
    confirmationNotAllowed: "Этот адрес нельзя подтвердить. Запросите новую ссылку.",
    unauthenticated: "Требуется войти в аккаунт.",
    notAllowed: "Действие недоступно для этого аккаунта.",
    notFound: "Запрошенные данные не найдены.",
    conflict: "Данные изменились. Обновите страницу и повторите попытку.",
    rateLimited: "Слишком много попыток. Повторите позже.",
    unavailable: "Сервис временно недоступен. Повторите попытку позже.",
    internal: "Не удалось выполнить запрос. Повторите попытку позже.",
    unknown: "Что-то пошло не так. Повторите попытку.",
    missingConfirmationToken: "В ссылке отсутствует токен подтверждения.",
    passwordResetInvalid: "Ссылка или код недействительны либо истекли.",
    passwordReused: "Этот пароль уже использовался. Придумайте новый пароль.",
    captchaRequired: "Пройдите проверку безопасности и повторите отправку.",
    captchaUnavailable: "Проверка безопасности временно недоступна. Повторите попытку позже.",
    antiBruteForceUnavailable: "Защита входа временно недоступна. Повторите попытку позже.",
  },
} as const;

export type RussianMessages = typeof ru;
